var sa = Object.defineProperty, aa = Object.defineProperties;
var ia = Object.getOwnPropertyDescriptors;
var Br = Object.getOwnPropertySymbols;
var oa = Object.prototype.hasOwnProperty, ua = Object.prototype.propertyIsEnumerable;
var qr = (t, e, n) => e in t ? sa(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Ue = (t, e) => {
  for (var n in e || (e = {}))
    oa.call(e, n) && qr(t, n, e[n]);
  if (Br)
    for (var n of Br(e))
      ua.call(e, n) && qr(t, n, e[n]);
  return t;
}, Kr = (t, e) => aa(t, ia(e));
var Be = (t, e, n) => new Promise((r, s) => {
  var a = (u) => {
    try {
      o(n.next(u));
    } catch (c) {
      s(c);
    }
  }, i = (u) => {
    try {
      o(n.throw(u));
    } catch (c) {
      s(c);
    }
  }, o = (u) => u.done ? r(u.value) : Promise.resolve(u.value).then(a, i);
  o((n = n.apply(t, e)).next());
});
import Gt, { useState as ca, useCallback as an, createContext as da, useEffect as la, useLayoutEffect as fa, useContext as ha, useRef as qe, useMemo as pa, useDebugValue as ma } from "react";
const ya = (t) => {
  let e = "";
  const n = new Uint8Array(t), r = n.byteLength;
  for (let s = 0; s < r; s++)
    e += String.fromCharCode(n[s]);
  return btoa(e);
};
var ga = Object.defineProperty, _a = (t, e, n) => e in t ? ga(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, tn = (t, e, n) => _a(t, typeof e != "symbol" ? e + "" : e, n);
class Hr extends Error {
  constructor(e, n) {
    super(e), tn(this, "type"), tn(this, "field"), tn(this, "value"), tn(this, "line"), this.name = "ParseError", this.type = n.type, this.field = n.field, this.value = n.value, this.line = n.line;
  }
}
function Rn(t) {
}
function va(t) {
  const { onEvent: e = Rn, onError: n = Rn, onRetry: r = Rn, onComment: s } = t;
  let a = "", i = !0, o, u = "", c = "";
  function h(l) {
    const v = i ? l.replace(/^\xEF\xBB\xBF/, "") : l, [m, z] = ba(`${a}${v}`);
    for (const R of m)
      p(R);
    a = z, i = !1;
  }
  function p(l) {
    if (l === "") {
      g();
      return;
    }
    if (l.startsWith(":")) {
      s && s(l.slice(l.startsWith(": ") ? 2 : 1));
      return;
    }
    const v = l.indexOf(":");
    if (v !== -1) {
      const m = l.slice(0, v), z = l[v + 1] === " " ? 2 : 1, R = l.slice(v + z);
      k(m, R, l);
      return;
    }
    k(l, "", l);
  }
  function k(l, v, m) {
    switch (l) {
      case "event":
        c = v;
        break;
      case "data":
        u = `${u}${v}
`;
        break;
      case "id":
        o = v.includes("\0") ? void 0 : v;
        break;
      case "retry":
        /^\d+$/.test(v) ? r(parseInt(v, 10)) : n(
          new Hr(`Invalid \`retry\` value: "${v}"`, {
            type: "invalid-retry",
            value: v,
            line: m
          })
        );
        break;
      default:
        n(
          new Hr(
            `Unknown field "${l.length > 20 ? `${l.slice(0, 20)}…` : l}"`,
            { type: "unknown-field", field: l, value: v, line: m }
          )
        );
        break;
    }
  }
  function g() {
    u.length > 0 && e({
      id: o,
      event: c || void 0,
      // If the data buffer's last character is a U+000A LINE FEED (LF) character,
      // then remove the last character from the data buffer.
      data: u.endsWith(`
`) ? u.slice(0, -1) : u
    }), o = void 0, u = "", c = "";
  }
  function b(l = {}) {
    a && l.consume && p(a), o = void 0, u = "", c = "", a = "";
  }
  return { feed: h, reset: b };
}
function ba(t) {
  const e = [];
  let n = "";
  const r = t.length;
  for (let s = 0; s < r; s++) {
    const a = t[s];
    a === "\r" && t[s + 1] === `
` ? (e.push(n), n = "", s++) : a === "\r" || a === `
` ? (e.push(n), n = "") : n += a;
  }
  return [e, n];
}
class Gr extends Event {
  /**
   * Constructs a new `ErrorEvent` instance. This is typically not called directly,
   * but rather emitted by the `EventSource` object when an error occurs.
   *
   * @param type - The type of the event (should be "error")
   * @param errorEventInitDict - Optional properties to include in the error event
   */
  constructor(e, n) {
    var r, s;
    super(e), this.code = (r = n == null ? void 0 : n.code) != null ? r : void 0, this.message = (s = n == null ? void 0 : n.message) != null ? s : void 0;
  }
  /**
   * Node.js "hides" the `message` and `code` properties of the `ErrorEvent` instance,
   * when it is `console.log`'ed. This makes it harder to debug errors. To ease debugging,
   * we explicitly include the properties in the `inspect` method.
   *
   * This is automatically called by Node.js when you `console.log` an instance of this class.
   *
   * @param _depth - The current depth
   * @param options - The options passed to `util.inspect`
   * @param inspect - The inspect function to use (prevents having to import it from `util`)
   * @returns A string representation of the error
   */
  [Symbol.for("nodejs.util.inspect.custom")](e, n, r) {
    return r(Jr(this), n);
  }
  /**
   * Deno "hides" the `message` and `code` properties of the `ErrorEvent` instance,
   * when it is `console.log`'ed. This makes it harder to debug errors. To ease debugging,
   * we explicitly include the properties in the `inspect` method.
   *
   * This is automatically called by Deno when you `console.log` an instance of this class.
   *
   * @param inspect - The inspect function to use (prevents having to import it from `util`)
   * @param options - The options passed to `Deno.inspect`
   * @returns A string representation of the error
   */
  [Symbol.for("Deno.customInspect")](e, n) {
    return e(Jr(this), n);
  }
}
function wa(t) {
  const e = globalThis.DOMException;
  return typeof e == "function" ? new e(t, "SyntaxError") : new SyntaxError(t);
}
function Kn(t) {
  return t instanceof Error ? "errors" in t && Array.isArray(t.errors) ? t.errors.map(Kn).join(", ") : "cause" in t && t.cause instanceof Error ? `${t}: ${Kn(t.cause)}` : t.message : `${t}`;
}
function Jr(t) {
  return {
    type: t.type,
    message: t.message,
    code: t.code,
    defaultPrevented: t.defaultPrevented,
    cancelable: t.cancelable,
    timeStamp: t.timeStamp
  };
}
var Ss = (t) => {
  throw TypeError(t);
}, Ar = (t, e, n) => e.has(t) || Ss("Cannot " + n), A = (t, e, n) => (Ar(t, e, "read from private field"), n ? n.call(t) : e.get(t)), U = (t, e, n) => e.has(t) ? Ss("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), L = (t, e, n, r) => (Ar(t, e, "write to private field"), e.set(t, n), n), Ce = (t, e, n) => (Ar(t, e, "access private method"), n), re, He, ut, on, fn, Nt, ft, Pt, Ze, ct, ht, dt, Et, fe, Hn, Gn, Jn, Xr, Xn, Yn, xt, Qn, er;
class un extends EventTarget {
  constructor(e, n) {
    var r, s;
    super(), U(this, fe), this.CONNECTING = 0, this.OPEN = 1, this.CLOSED = 2, U(this, re), U(this, He), U(this, ut), U(this, on), U(this, fn), U(this, Nt), U(this, ft), U(this, Pt, null), U(this, Ze), U(this, ct), U(this, ht, null), U(this, dt, null), U(this, Et, null), U(this, Gn, (a) => Be(this, null, function* () {
      var i;
      A(this, ct).reset();
      const { body: o, redirected: u, status: c, headers: h } = a;
      if (c === 204) {
        Ce(this, fe, xt).call(this, "Server sent HTTP 204, not reconnecting", 204), this.close();
        return;
      }
      if (u ? L(this, ut, new URL(a.url)) : L(this, ut, void 0), c !== 200) {
        Ce(this, fe, xt).call(this, `Non-200 status code (${c})`, c);
        return;
      }
      if (!(h.get("content-type") || "").startsWith("text/event-stream")) {
        Ce(this, fe, xt).call(this, 'Invalid content type, expected "text/event-stream"', c);
        return;
      }
      if (A(this, re) === this.CLOSED)
        return;
      L(this, re, this.OPEN);
      const p = new Event("open");
      if ((i = A(this, Et)) == null || i.call(this, p), this.dispatchEvent(p), typeof o != "object" || !o || !("getReader" in o)) {
        Ce(this, fe, xt).call(this, "Invalid response body, expected a web ReadableStream", c), this.close();
        return;
      }
      const k = new TextDecoder(), g = o.getReader();
      let b = !0;
      do {
        const { done: l, value: v } = yield g.read();
        v && A(this, ct).feed(k.decode(v, { stream: !l })), l && (b = !1, A(this, ct).reset(), Ce(this, fe, Qn).call(this));
      } while (b);
    })), U(this, Jn, (a) => {
      L(this, Ze, void 0), !(a.name === "AbortError" || a.type === "aborted") && Ce(this, fe, Qn).call(this, Kn(a));
    }), U(this, Xn, (a) => {
      typeof a.id == "string" && L(this, Pt, a.id);
      const i = new MessageEvent(a.event || "message", {
        data: a.data,
        origin: A(this, ut) ? A(this, ut).origin : A(this, He).origin,
        lastEventId: a.id || ""
      });
      A(this, dt) && (!a.event || a.event === "message") && A(this, dt).call(this, i), this.dispatchEvent(i);
    }), U(this, Yn, (a) => {
      L(this, Nt, a);
    }), U(this, er, () => {
      L(this, ft, void 0), A(this, re) === this.CONNECTING && Ce(this, fe, Hn).call(this);
    });
    try {
      if (e instanceof URL)
        L(this, He, e);
      else if (typeof e == "string")
        L(this, He, new URL(e, ka()));
      else
        throw new Error("Invalid URL");
    } catch (a) {
      throw wa("An invalid or illegal string was specified");
    }
    L(this, ct, va({
      onEvent: A(this, Xn),
      onRetry: A(this, Yn)
    })), L(this, re, this.CONNECTING), L(this, Nt, 3e3), L(this, fn, (r = n == null ? void 0 : n.fetch) != null ? r : globalThis.fetch), L(this, on, (s = n == null ? void 0 : n.withCredentials) != null ? s : !1), Ce(this, fe, Hn).call(this);
  }
  /**
   * Returns the state of this EventSource object's connection. It can have the values described below.
   *
   * [MDN Reference](https://developer.mozilla.org/docs/Web/API/EventSource/readyState)
   *
   * Note: typed as `number` instead of `0 | 1 | 2` for compatibility with the `EventSource` interface,
   * defined in the TypeScript `dom` library.
   *
   * @public
   */
  get readyState() {
    return A(this, re);
  }
  /**
   * Returns the URL providing the event stream.
   *
   * [MDN Reference](https://developer.mozilla.org/docs/Web/API/EventSource/url)
   *
   * @public
   */
  get url() {
    return A(this, He).href;
  }
  /**
   * Returns true if the credentials mode for connection requests to the URL providing the event stream is set to "include", and false otherwise.
   *
   * [MDN Reference](https://developer.mozilla.org/docs/Web/API/EventSource/withCredentials)
   */
  get withCredentials() {
    return A(this, on);
  }
  /** [MDN Reference](https://developer.mozilla.org/docs/Web/API/EventSource/error_event) */
  get onerror() {
    return A(this, ht);
  }
  set onerror(e) {
    L(this, ht, e);
  }
  /** [MDN Reference](https://developer.mozilla.org/docs/Web/API/EventSource/message_event) */
  get onmessage() {
    return A(this, dt);
  }
  set onmessage(e) {
    L(this, dt, e);
  }
  /** [MDN Reference](https://developer.mozilla.org/docs/Web/API/EventSource/open_event) */
  get onopen() {
    return A(this, Et);
  }
  set onopen(e) {
    L(this, Et, e);
  }
  addEventListener(e, n, r) {
    const s = n;
    super.addEventListener(e, s, r);
  }
  removeEventListener(e, n, r) {
    const s = n;
    super.removeEventListener(e, s, r);
  }
  /**
   * Aborts any instances of the fetch algorithm started for this EventSource object, and sets the readyState attribute to CLOSED.
   *
   * [MDN Reference](https://developer.mozilla.org/docs/Web/API/EventSource/close)
   *
   * @public
   */
  close() {
    A(this, ft) && clearTimeout(A(this, ft)), A(this, re) !== this.CLOSED && (A(this, Ze) && A(this, Ze).abort(), L(this, re, this.CLOSED), L(this, Ze, void 0));
  }
}
re = /* @__PURE__ */ new WeakMap(), He = /* @__PURE__ */ new WeakMap(), ut = /* @__PURE__ */ new WeakMap(), on = /* @__PURE__ */ new WeakMap(), fn = /* @__PURE__ */ new WeakMap(), Nt = /* @__PURE__ */ new WeakMap(), ft = /* @__PURE__ */ new WeakMap(), Pt = /* @__PURE__ */ new WeakMap(), Ze = /* @__PURE__ */ new WeakMap(), ct = /* @__PURE__ */ new WeakMap(), ht = /* @__PURE__ */ new WeakMap(), dt = /* @__PURE__ */ new WeakMap(), Et = /* @__PURE__ */ new WeakMap(), fe = /* @__PURE__ */ new WeakSet(), /**
* Connect to the given URL and start receiving events
*
* @internal
*/
Hn = function() {
  L(this, re, this.CONNECTING), L(this, Ze, new AbortController()), A(this, fn)(A(this, He), Ce(this, fe, Xr).call(this)).then(A(this, Gn)).catch(A(this, Jn));
}, Gn = /* @__PURE__ */ new WeakMap(), Jn = /* @__PURE__ */ new WeakMap(), /**
* Get request options for the `fetch()` request
*
* @returns The request options
* @internal
*/
Xr = function() {
  var t;
  const e = {
    // [spec] Let `corsAttributeState` be `Anonymous`…
    // [spec] …will have their mode set to "cors"…
    mode: "cors",
    redirect: "follow",
    headers: Ue({ Accept: "text/event-stream" }, A(this, Pt) ? { "Last-Event-ID": A(this, Pt) } : void 0),
    cache: "no-store",
    signal: (t = A(this, Ze)) == null ? void 0 : t.signal
  };
  return "window" in globalThis && (e.credentials = this.withCredentials ? "include" : "same-origin"), e;
}, Xn = /* @__PURE__ */ new WeakMap(), Yn = /* @__PURE__ */ new WeakMap(), /**
* Handles the process referred to in the EventSource specification as "failing a connection".
*
* @param error - The error causing the connection to fail
* @param code - The HTTP status code, if available
* @internal
*/
xt = function(t, e) {
  var n;
  A(this, re) !== this.CLOSED && L(this, re, this.CLOSED);
  const r = new Gr("error", { code: e, message: t });
  (n = A(this, ht)) == null || n.call(this, r), this.dispatchEvent(r);
}, /**
* Schedules a reconnection attempt against the EventSource endpoint.
*
* @param message - The error causing the connection to fail
* @param code - The HTTP status code, if available
* @internal
*/
Qn = function(t, e) {
  var n;
  if (A(this, re) === this.CLOSED)
    return;
  L(this, re, this.CONNECTING);
  const r = new Gr("error", { code: e, message: t });
  (n = A(this, ht)) == null || n.call(this, r), this.dispatchEvent(r), L(this, ft, setTimeout(A(this, er), A(this, Nt)));
}, er = /* @__PURE__ */ new WeakMap(), /**
* ReadyState representing an EventSource currently trying to connect
*
* @public
*/
un.CONNECTING = 0, /**
* ReadyState representing an EventSource connection that is open (eg connected)
*
* @public
*/
un.OPEN = 1, /**
* ReadyState representing an EventSource connection that is closed (eg disconnected)
*
* @public
*/
un.CLOSED = 2;
function ka() {
  const t = "document" in globalThis ? globalThis.document : void 0;
  return t && typeof t == "object" && "baseURI" in t && typeof t.baseURI == "string" ? t.baseURI : void 0;
}
var Os = Symbol.for("immer-nothing"), Yr = Symbol.for("immer-draftable"), oe = Symbol.for("immer-state"), Ea = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(t) {
    return `The plugin for '${t}' has not been loaded into Immer. To enable the plugin, import and call \`enable${t}()\` when initializing your application.`;
  },
  function(t) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${t}'`;
  },
  "This object has been frozen and should not be mutated",
  function(t) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + t;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(t) {
    return `'current' expects a draft, got: ${t}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(t) {
    return `'original' expects a draft, got: ${t}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function se(t, ...e) {
  if (process.env.NODE_ENV !== "production") {
    const n = Ea[t], r = typeof n == "function" ? n.apply(null, e) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${t}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var mt = Object.getPrototypeOf;
function yt(t) {
  return !!t && !!t[oe];
}
function Ye(t) {
  var e;
  return t ? Ts(t) || Array.isArray(t) || !!t[Yr] || !!((e = t.constructor) != null && e[Yr]) || Sn(t) || On(t) : !1;
}
var xa = Object.prototype.constructor.toString();
function Ts(t) {
  if (!t || typeof t != "object")
    return !1;
  const e = mt(t);
  if (e === null)
    return !0;
  const n = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === xa;
}
function hn(t, e) {
  xn(t) === 0 ? Reflect.ownKeys(t).forEach((n) => {
    e(n, t[n], t);
  }) : t.forEach((n, r) => e(r, n, t));
}
function xn(t) {
  const e = t[oe];
  return e ? e.type_ : Array.isArray(t) ? 1 : Sn(t) ? 2 : On(t) ? 3 : 0;
}
function tr(t, e) {
  return xn(t) === 2 ? t.has(e) : Object.prototype.hasOwnProperty.call(t, e);
}
function As(t, e, n) {
  const r = xn(t);
  r === 2 ? t.set(e, n) : r === 3 ? t.add(n) : t[e] = n;
}
function Sa(t, e) {
  return t === e ? t !== 0 || 1 / t === 1 / e : t !== t && e !== e;
}
function Sn(t) {
  return t instanceof Map;
}
function On(t) {
  return t instanceof Set;
}
function Ke(t) {
  return t.copy_ || t.base_;
}
function nr(t, e) {
  if (Sn(t))
    return new Map(t);
  if (On(t))
    return new Set(t);
  if (Array.isArray(t))
    return Array.prototype.slice.call(t);
  const n = Ts(t);
  if (e === !0 || e === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(t);
    delete r[oe];
    let s = Reflect.ownKeys(r);
    for (let a = 0; a < s.length; a++) {
      const i = s[a], o = r[i];
      o.writable === !1 && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: o.enumerable,
        value: t[i]
      });
    }
    return Object.create(mt(t), r);
  } else {
    const r = mt(t);
    if (r !== null && n)
      return Ue({}, t);
    const s = Object.create(r);
    return Object.assign(s, t);
  }
}
function Rt(t, e = !1) {
  return Tn(t) || yt(t) || !Ye(t) || (xn(t) > 1 && (t.set = t.add = t.clear = t.delete = Oa), Object.freeze(t), e && Object.entries(t).forEach(([n, r]) => Rt(r, !0))), t;
}
function Oa() {
  se(2);
}
function Tn(t) {
  return Object.isFrozen(t);
}
var Ta = {};
function Qe(t) {
  const e = Ta[t];
  return e || se(0, t), e;
}
var It;
function Cs() {
  return It;
}
function Aa(t, e) {
  return {
    drafts_: [],
    parent_: t,
    immer_: e,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function Qr(t, e) {
  e && (Qe("Patches"), t.patches_ = [], t.inversePatches_ = [], t.patchListener_ = e);
}
function rr(t) {
  sr(t), t.drafts_.forEach(Ca), t.drafts_ = null;
}
function sr(t) {
  t === It && (It = t.parent_);
}
function es(t) {
  return It = Aa(It, t);
}
function Ca(t) {
  const e = t[oe];
  e.type_ === 0 || e.type_ === 1 ? e.revoke_() : e.revoked_ = !0;
}
function ts(t, e) {
  e.unfinalizedDrafts_ = e.drafts_.length;
  const n = e.drafts_[0];
  return t !== void 0 && t !== n ? (n[oe].modified_ && (rr(e), se(4)), Ye(t) && (t = pn(e, t), e.parent_ || mn(e, t)), e.patches_ && Qe("Patches").generateReplacementPatches_(
    n[oe].base_,
    t,
    e.patches_,
    e.inversePatches_
  )) : t = pn(e, n, []), rr(e), e.patches_ && e.patchListener_(e.patches_, e.inversePatches_), t !== Os ? t : void 0;
}
function pn(t, e, n) {
  if (Tn(e))
    return e;
  const r = e[oe];
  if (!r)
    return hn(
      e,
      (s, a) => ns(t, r, e, s, a, n)
    ), e;
  if (r.scope_ !== t)
    return e;
  if (!r.modified_)
    return mn(t, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const s = r.copy_;
    let a = s, i = !1;
    r.type_ === 3 && (a = new Set(s), s.clear(), i = !0), hn(
      a,
      (o, u) => ns(t, r, s, o, u, n, i)
    ), mn(t, s, !1), n && t.patches_ && Qe("Patches").generatePatches_(
      r,
      n,
      t.patches_,
      t.inversePatches_
    );
  }
  return r.copy_;
}
function ns(t, e, n, r, s, a, i) {
  if (process.env.NODE_ENV !== "production" && s === n && se(5), yt(s)) {
    const o = a && e && e.type_ !== 3 && // Set objects are atomic since they have no keys.
    !tr(e.assigned_, r) ? a.concat(r) : void 0, u = pn(t, s, o);
    if (As(n, r, u), yt(u))
      t.canAutoFreeze_ = !1;
    else
      return;
  } else i && n.add(s);
  if (Ye(s) && !Tn(s)) {
    if (!t.immer_.autoFreeze_ && t.unfinalizedDrafts_ < 1)
      return;
    pn(t, s), (!e || !e.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && mn(t, s);
  }
}
function mn(t, e, n = !1) {
  !t.parent_ && t.immer_.autoFreeze_ && t.canAutoFreeze_ && Rt(e, n);
}
function Na(t, e) {
  const n = Array.isArray(t), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: e ? e.scope_ : Cs(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: e,
    // The base state.
    base_: t,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let s = r, a = Cr;
  n && (s = [r], a = jt);
  const { revoke: i, proxy: o } = Proxy.revocable(s, a);
  return r.draft_ = o, r.revoke_ = i, o;
}
var Cr = {
  get(t, e) {
    if (e === oe)
      return t;
    const n = Ke(t);
    if (!tr(n, e))
      return Pa(t, n, e);
    const r = n[e];
    return t.finalized_ || !Ye(r) ? r : r === In(t.base_, e) ? (jn(t), t.copy_[e] = ir(r, t)) : r;
  },
  has(t, e) {
    return e in Ke(t);
  },
  ownKeys(t) {
    return Reflect.ownKeys(Ke(t));
  },
  set(t, e, n) {
    const r = Ns(Ke(t), e);
    if (r != null && r.set)
      return r.set.call(t.draft_, n), !0;
    if (!t.modified_) {
      const s = In(Ke(t), e), a = s == null ? void 0 : s[oe];
      if (a && a.base_ === n)
        return t.copy_[e] = n, t.assigned_[e] = !1, !0;
      if (Sa(n, s) && (n !== void 0 || tr(t.base_, e)))
        return !0;
      jn(t), ar(t);
    }
    return t.copy_[e] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || e in t.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(t.copy_[e]) || (t.copy_[e] = n, t.assigned_[e] = !0), !0;
  },
  deleteProperty(t, e) {
    return In(t.base_, e) !== void 0 || e in t.base_ ? (t.assigned_[e] = !1, jn(t), ar(t)) : delete t.assigned_[e], t.copy_ && delete t.copy_[e], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(t, e) {
    const n = Ke(t), r = Reflect.getOwnPropertyDescriptor(n, e);
    return r && {
      writable: !0,
      configurable: t.type_ !== 1 || e !== "length",
      enumerable: r.enumerable,
      value: n[e]
    };
  },
  defineProperty() {
    se(11);
  },
  getPrototypeOf(t) {
    return mt(t.base_);
  },
  setPrototypeOf() {
    se(12);
  }
}, jt = {};
hn(Cr, (t, e) => {
  jt[t] = function() {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
});
jt.deleteProperty = function(t, e) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(e)) && se(13), jt.set.call(this, t, e, void 0);
};
jt.set = function(t, e, n) {
  return process.env.NODE_ENV !== "production" && e !== "length" && isNaN(parseInt(e)) && se(14), Cr.set.call(this, t[0], e, n, t[0]);
};
function In(t, e) {
  const n = t[oe];
  return (n ? Ke(n) : t)[e];
}
function Pa(t, e, n) {
  var s;
  const r = Ns(e, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (s = r.get) == null ? void 0 : s.call(t.draft_)
  ) : void 0;
}
function Ns(t, e) {
  if (!(e in t))
    return;
  let n = mt(t);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, e);
    if (r)
      return r;
    n = mt(n);
  }
}
function ar(t) {
  t.modified_ || (t.modified_ = !0, t.parent_ && ar(t.parent_));
}
function jn(t) {
  t.copy_ || (t.copy_ = nr(
    t.base_,
    t.scope_.immer_.useStrictShallowCopy_
  ));
}
var Ra = class {
  constructor(t) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (e, n, r) => {
      if (typeof e == "function" && typeof n != "function") {
        const a = n;
        n = e;
        const i = this;
        return function(u = a, ...c) {
          return i.produce(u, (h) => n.call(this, h, ...c));
        };
      }
      typeof n != "function" && se(6), r !== void 0 && typeof r != "function" && se(7);
      let s;
      if (Ye(e)) {
        const a = es(this), i = ir(e, void 0);
        let o = !0;
        try {
          s = n(i), o = !1;
        } finally {
          o ? rr(a) : sr(a);
        }
        return Qr(a, r), ts(s, a);
      } else if (!e || typeof e != "object") {
        if (s = n(e), s === void 0 && (s = e), s === Os && (s = void 0), this.autoFreeze_ && Rt(s, !0), r) {
          const a = [], i = [];
          Qe("Patches").generateReplacementPatches_(e, s, a, i), r(a, i);
        }
        return s;
      } else
        se(1, e);
    }, this.produceWithPatches = (e, n) => {
      if (typeof e == "function")
        return (i, ...o) => this.produceWithPatches(i, (u) => e(u, ...o));
      let r, s;
      return [this.produce(e, n, (i, o) => {
        r = i, s = o;
      }), r, s];
    }, typeof (t == null ? void 0 : t.autoFreeze) == "boolean" && this.setAutoFreeze(t.autoFreeze), typeof (t == null ? void 0 : t.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(t.useStrictShallowCopy);
  }
  createDraft(t) {
    Ye(t) || se(8), yt(t) && (t = Ia(t));
    const e = es(this), n = ir(t, void 0);
    return n[oe].isManual_ = !0, sr(e), n;
  }
  finishDraft(t, e) {
    const n = t && t[oe];
    (!n || !n.isManual_) && se(9);
    const { scope_: r } = n;
    return Qr(r, e), ts(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(t) {
    this.autoFreeze_ = t;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(t) {
    this.useStrictShallowCopy_ = t;
  }
  applyPatches(t, e) {
    let n;
    for (n = e.length - 1; n >= 0; n--) {
      const s = e[n];
      if (s.path.length === 0 && s.op === "replace") {
        t = s.value;
        break;
      }
    }
    n > -1 && (e = e.slice(n + 1));
    const r = Qe("Patches").applyPatches_;
    return yt(t) ? r(t, e) : this.produce(
      t,
      (s) => r(s, e)
    );
  }
};
function ir(t, e) {
  const n = Sn(t) ? Qe("MapSet").proxyMap_(t, e) : On(t) ? Qe("MapSet").proxySet_(t, e) : Na(t, e);
  return (e ? e.scope_ : Cs()).drafts_.push(n), n;
}
function Ia(t) {
  return yt(t) || se(10, t), Ps(t);
}
function Ps(t) {
  if (!Ye(t) || Tn(t))
    return t;
  const e = t[oe];
  let n;
  if (e) {
    if (!e.modified_)
      return e.base_;
    e.finalized_ = !0, n = nr(t, e.scope_.immer_.useStrictShallowCopy_);
  } else
    n = nr(t, !0);
  return hn(n, (r, s) => {
    As(n, r, Ps(s));
  }), e && (e.finalized_ = !1), n;
}
var ue = new Ra(), ja = ue.produce;
ue.produceWithPatches.bind(
  ue
);
ue.setAutoFreeze.bind(ue);
ue.setUseStrictShallowCopy.bind(ue);
ue.applyPatches.bind(ue);
ue.createDraft.bind(ue);
ue.finishDraft.bind(ue);
function Za(t) {
  var e = ca(function() {
    return Rt(typeof t == "function" ? t() : t, !0);
  }), n = e[1];
  return [e[0], an(function(r) {
    n(typeof r == "function" ? ja(r) : Rt(r));
  }, [])];
}
const rs = {
  status: "idle",
  error: null,
  result: null,
  tasks: {
    fetchDesign: { status: "pending" },
    codeGeneration: { status: "pending", progress: 0 },
    uploadAssets: { status: "pending" }
  }
}, ss = (t) => "path" in t ? {
  filePath: t.path.replace(/^\//, ""),
  referencePath: t.path === "/" ? "" : t.path
  // Workaround to avoid duplicated slashes in the URL. Ideally, the fix should be done in Codegen.
} : {
  filePath: t.filePath.replace(/^\//, ""),
  referencePath: t.referencePath === "/" ? "" : t.referencePath
}, Au = ({
  url: t,
  method: e = "POST"
}) => {
  const [n, r] = Za(rs);
  return {
    getCode: (a) => Be(void 0, null, function* () {
      var c, h, p, k;
      r((g) => {
        g.status = "pending", g.error = null, g.result = null, g.tasks = rs.tasks;
      });
      const i = structuredClone(a);
      if (((c = a.assetsStorage) == null ? void 0 : c.strategy) === "local") {
        const { referencePath: g } = ss(
          a.assetsStorage
        );
        a.assetsStorage = {
          strategy: "external",
          url: g
        };
      }
      const o = new un(t, {
        fetch: (g, b) => fetch(g, Kr(Ue({}, b), {
          method: e,
          body: JSON.stringify(a)
        }))
      }), u = new Promise((g) => {
        const b = {};
        o.addEventListener("start", (l) => {
          const v = JSON.parse(l.data);
          b.sessionId = v.sessionId, r((m) => {
            m.tasks.fetchDesign.status = "running";
          });
        }), o.addEventListener("pre_codegen", (l) => {
          JSON.parse(
            l.data
          ).message === "Anima model built" && r((m) => {
            m.tasks.fetchDesign.status = "finished", m.tasks.codeGeneration.status = "running", m.tasks.uploadAssets.status = "running";
          });
        }), o.addEventListener("figma_metadata", (l) => {
          const v = JSON.parse(
            l.data
          );
          b.figmaFileName = v.figmaFileName, b.figmaSelectedFrameName = v.figmaSelectedFrameName;
        }), o.addEventListener("aborted", () => {
          r((l) => {
            l.status = "aborted";
          }), g({
            result: null,
            error: new Error("The request was aborted")
          });
        }), o.addEventListener("generating_code", (l) => {
          const v = JSON.parse(
            l.data
          );
          v.payload.status === "success" && (b.files = v.payload.files), r((m) => {
            m.tasks.codeGeneration.progress = v.payload.progress, m.tasks.codeGeneration.status = "running";
          });
        }), o.addEventListener("codegen_completed", () => {
          r((l) => {
            l.tasks.codeGeneration.status = "finished";
          });
        }), o.addEventListener("assets_uploaded", () => {
          r((l) => {
            l.tasks.uploadAssets.status = "finished";
          });
        }), o.addEventListener("assets_list", (l) => {
          const v = JSON.parse(
            l.data
          );
          b.assets = v.payload.assets;
        }), o.addEventListener("error", (l) => {
          if (l instanceof MessageEvent) {
            const v = JSON.parse(
              l.data
            );
            r((m) => {
              m.status = "error", m.error = new Error(v.payload.message);
            }), g({
              result: null,
              error: new Error(v.payload.message)
            });
          } else
            console.error("EventSource error:", l), r((v) => {
              v.status = "error", v.error = new Error("HTTP error: " + l.message);
            }), g({
              result: null,
              error: new Error("HTTP error: " + l.message)
            });
        }), o.addEventListener("done", (l) => {
          const v = JSON.parse(l.data);
          b.tokenUsage = v.payload.tokenUsage, r((m) => {
            m.status = "success", m.result = b;
          }), g({ result: b, error: null });
        });
      });
      try {
        const { result: g, error: b } = yield u, l = structuredClone(g);
        if (((h = i.assetsStorage) == null ? void 0 : h.strategy) === "local" && ((p = l == null ? void 0 : l.assets) != null && p.length)) {
          const { filePath: v } = ss(
            i.assetsStorage
          ), m = l.assets.map((R) => Be(void 0, null, function* () {
            const D = yield (yield fetch(R.url)).arrayBuffer();
            return {
              assetName: R.name,
              base64: ya(D)
            };
          })), z = yield Promise.allSettled(m);
          for (const R of z) {
            const q = {};
            if (R.status === "fulfilled") {
              const { assetName: D, base64: B } = R.value;
              q[D] = B;
              const I = v ? `${v}/${D}` : D;
              l.files[I] = {
                content: B,
                isBinary: !0
              };
            }
          }
        }
        return b ? { result: null, error: b } : Object.keys((k = l == null ? void 0 : l.files) != null ? k : {}).length === 0 ? {
          result: null,
          error: new Error("No files received")
        } : { result: l, error: b };
      } finally {
        o.close();
      }
    }),
    status: n.status,
    tasks: n.tasks,
    error: n.error,
    result: n.result
  };
};
var nn = { exports: {} }, Zn = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var as;
function Da() {
  if (as) return Zn;
  as = 1;
  var t = Gt;
  function e(p, k) {
    return p === k && (p !== 0 || 1 / p === 1 / k) || p !== p && k !== k;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, s = t.useEffect, a = t.useLayoutEffect, i = t.useDebugValue;
  function o(p, k) {
    var g = k(), b = r({ inst: { value: g, getSnapshot: k } }), l = b[0].inst, v = b[1];
    return a(
      function() {
        l.value = g, l.getSnapshot = k, u(l) && v({ inst: l });
      },
      [p, g, k]
    ), s(
      function() {
        return u(l) && v({ inst: l }), p(function() {
          u(l) && v({ inst: l });
        });
      },
      [p]
    ), i(g), g;
  }
  function u(p) {
    var k = p.getSnapshot;
    p = p.value;
    try {
      var g = k();
      return !n(p, g);
    } catch (b) {
      return !0;
    }
  }
  function c(p, k) {
    return k();
  }
  var h = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? c : o;
  return Zn.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : h, Zn;
}
var Dn = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var is;
function Ma() {
  return is || (is = 1, process.env.NODE_ENV !== "production" && function() {
    function t(g, b) {
      return g === b && (g !== 0 || 1 / g === 1 / b) || g !== g && b !== b;
    }
    function e(g, b) {
      h || s.startTransition === void 0 || (h = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var l = b();
      if (!p) {
        var v = b();
        a(l, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), p = !0);
      }
      v = i({
        inst: { value: l, getSnapshot: b }
      });
      var m = v[0].inst, z = v[1];
      return u(
        function() {
          m.value = l, m.getSnapshot = b, n(m) && z({ inst: m });
        },
        [g, l, b]
      ), o(
        function() {
          return n(m) && z({ inst: m }), g(function() {
            n(m) && z({ inst: m });
          });
        },
        [g]
      ), c(l), l;
    }
    function n(g) {
      var b = g.getSnapshot;
      g = g.value;
      try {
        var l = b();
        return !a(g, l);
      } catch (v) {
        return !0;
      }
    }
    function r(g, b) {
      return b();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var s = Gt, a = typeof Object.is == "function" ? Object.is : t, i = s.useState, o = s.useEffect, u = s.useLayoutEffect, c = s.useDebugValue, h = !1, p = !1, k = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? r : e;
    Dn.useSyncExternalStore = s.useSyncExternalStore !== void 0 ? s.useSyncExternalStore : k, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Dn;
}
var os;
function La() {
  return os || (os = 1, process.env.NODE_ENV === "production" ? nn.exports = Da() : nn.exports = Ma()), nn.exports;
}
var $a = La();
const Rs = 0, Is = 1, js = 2, us = 3;
var cs = Object.prototype.hasOwnProperty;
function or(t, e) {
  var n, r;
  if (t === e) return !0;
  if (t && e && (n = t.constructor) === e.constructor) {
    if (n === Date) return t.getTime() === e.getTime();
    if (n === RegExp) return t.toString() === e.toString();
    if (n === Array) {
      if ((r = t.length) === e.length)
        for (; r-- && or(t[r], e[r]); ) ;
      return r === -1;
    }
    if (!n || typeof t == "object") {
      r = 0;
      for (n in t)
        if (cs.call(t, n) && ++r && !cs.call(e, n) || !(n in e) || !or(t[n], e[n])) return !1;
      return Object.keys(e).length === r;
    }
  }
  return t !== t && e !== e;
}
const Pe = /* @__PURE__ */ new WeakMap(), De = () => {
}, ee = (
  /*#__NOINLINE__*/
  De()
), ur = Object, N = (t) => t === ee, be = (t) => typeof t == "function", Me = (t, e) => Ue(Ue({}, t), e), Zs = (t) => be(t.then), Mn = {}, rn = {}, Nr = "undefined", Jt = typeof window != Nr, cr = typeof document != Nr, Fa = Jt && "Deno" in window, Wa = () => Jt && typeof window.requestAnimationFrame != Nr, Ds = (t, e) => {
  const n = Pe.get(t);
  return [
    // Getter
    () => !N(e) && t.get(e) || Mn,
    // Setter
    (r) => {
      if (!N(e)) {
        const s = t.get(e);
        e in rn || (rn[e] = s), n[5](e, Me(s, r), s || Mn);
      }
    },
    // Subscriber
    n[6],
    // Get server cache snapshot
    () => !N(e) && e in rn ? rn[e] : !N(e) && t.get(e) || Mn
  ];
};
let dr = !0;
const za = () => dr, [lr, fr] = Jt && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  De,
  De
], Va = () => {
  const t = cr && document.visibilityState;
  return N(t) || t !== "hidden";
}, Ua = (t) => (cr && document.addEventListener("visibilitychange", t), lr("focus", t), () => {
  cr && document.removeEventListener("visibilitychange", t), fr("focus", t);
}), Ba = (t) => {
  const e = () => {
    dr = !0, t();
  }, n = () => {
    dr = !1;
  };
  return lr("online", e), lr("offline", n), () => {
    fr("online", e), fr("offline", n);
  };
}, qa = {
  isOnline: za,
  isVisible: Va
}, Ka = {
  initFocus: Ua,
  initReconnect: Ba
}, ds = !Gt.useId, Zt = !Jt || Fa, Ha = (t) => Wa() ? window.requestAnimationFrame(t) : setTimeout(t, 1), Ln = Zt ? la : fa, $n = typeof navigator != "undefined" && navigator.connection, ls = !Zt && $n && ([
  "slow-2g",
  "2g"
].includes($n.effectiveType) || $n.saveData), sn = /* @__PURE__ */ new WeakMap(), Fn = (t, e) => ur.prototype.toString.call(t) === `[object ${e}]`;
let Ga = 0;
const hr = (t) => {
  const e = typeof t, n = Fn(t, "Date"), r = Fn(t, "RegExp"), s = Fn(t, "Object");
  let a, i;
  if (ur(t) === t && !n && !r) {
    if (a = sn.get(t), a) return a;
    if (a = ++Ga + "~", sn.set(t, a), Array.isArray(t)) {
      for (a = "@", i = 0; i < t.length; i++)
        a += hr(t[i]) + ",";
      sn.set(t, a);
    }
    if (s) {
      a = "#";
      const o = ur.keys(t).sort();
      for (; !N(i = o.pop()); )
        N(t[i]) || (a += i + ":" + hr(t[i]) + ",");
      sn.set(t, a);
    }
  } else
    a = n ? t.toJSON() : e == "symbol" ? t.toString() : e == "string" ? JSON.stringify(t) : "" + t;
  return a;
}, Pr = (t) => {
  if (be(t))
    try {
      t = t();
    } catch (n) {
      t = "";
    }
  const e = t;
  return t = typeof t == "string" ? t : (Array.isArray(t) ? t.length : t) ? hr(t) : "", [
    t,
    e
  ];
};
let Ja = 0;
const pr = () => ++Ja;
function Ms(...t) {
  return Be(this, null, function* () {
    const [e, n, r, s] = t, a = Me({
      populateCache: !0,
      throwOnError: !0
    }, typeof s == "boolean" ? {
      revalidate: s
    } : s || {});
    let i = a.populateCache;
    const o = a.rollbackOnError;
    let u = a.optimisticData;
    const c = (k) => typeof o == "function" ? o(k) : o !== !1, h = a.throwOnError;
    if (be(n)) {
      const k = n, g = [], b = e.keys();
      for (const l of b)
        // Skip the special useSWRInfinite and useSWRSubscription keys.
        !/^\$(inf|sub)\$/.test(l) && k(e.get(l)._k) && g.push(l);
      return Promise.all(g.map(p));
    }
    return p(n);
    function p(k) {
      return Be(this, null, function* () {
        const [g] = Pr(k);
        if (!g) return;
        const [b, l] = Ds(e, g), [v, m, z, R] = Pe.get(e), q = () => {
          const le = v[g];
          return (be(a.revalidate) ? a.revalidate(b().data, k) : a.revalidate !== !1) && (delete z[g], delete R[g], le && le[0]) ? le[0](js).then(() => b().data) : b().data;
        };
        if (t.length < 3)
          return q();
        let D = r, B;
        const I = pr();
        m[g] = [
          I,
          0
        ];
        const $ = !N(u), Se = b(), M = Se.data, rt = Se._c, ze = N(rt) ? M : rt;
        if ($ && (u = be(u) ? u(ze, M) : u, l({
          data: u,
          _c: ze
        })), be(D))
          try {
            D = D(ze);
          } catch (le) {
            B = le;
          }
        if (D && Zs(D))
          if (D = yield D.catch((le) => {
            B = le;
          }), I !== m[g][0]) {
            if (B) throw B;
            return D;
          } else B && $ && c(B) && (i = !0, l({
            data: ze,
            _c: ee
          }));
        if (i && !B)
          if (be(i)) {
            const le = i(D, ze);
            l({
              data: le,
              error: ee,
              _c: ee
            });
          } else
            l({
              data: D,
              error: ee,
              _c: ee
            });
        if (m[g][1] = pr(), Promise.resolve(q()).then(() => {
          l({
            _c: ee
          });
        }), B) {
          if (h) throw B;
          return;
        }
        return D;
      });
    }
  });
}
const fs = (t, e) => {
  for (const n in t)
    t[n][0] && t[n][0](e);
}, Xa = (t, e) => {
  if (!Pe.has(t)) {
    const n = Me(Ka, e), r = {}, s = Ms.bind(ee, t);
    let a = De;
    const i = {}, o = (h, p) => {
      const k = i[h] || [];
      return i[h] = k, k.push(p), () => k.splice(k.indexOf(p), 1);
    }, u = (h, p, k) => {
      t.set(h, p);
      const g = i[h];
      if (g)
        for (const b of g)
          b(p, k);
    }, c = () => {
      if (!Pe.has(t) && (Pe.set(t, [
        r,
        {},
        {},
        {},
        s,
        u,
        o
      ]), !Zt)) {
        const h = n.initFocus(setTimeout.bind(ee, fs.bind(ee, r, Rs))), p = n.initReconnect(setTimeout.bind(ee, fs.bind(ee, r, Is)));
        a = () => {
          h && h(), p && p(), Pe.delete(t);
        };
      }
    };
    return c(), [
      t,
      s,
      c,
      a
    ];
  }
  return [
    t,
    Pe.get(t)[4]
  ];
}, Ya = (t, e, n, r, s) => {
  const a = n.errorRetryCount, i = s.retryCount, o = ~~((Math.random() + 0.5) * (1 << (i < 8 ? i : 8))) * n.errorRetryInterval;
  !N(a) && i > a || setTimeout(r, o, s);
}, Qa = or, [Ls, ei] = Xa(/* @__PURE__ */ new Map()), ti = Me(
  {
    // events
    onLoadingSlow: De,
    onSuccess: De,
    onError: De,
    onErrorRetry: Ya,
    onDiscarded: De,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: ls ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: ls ? 5e3 : 3e3,
    // providers
    compare: Qa,
    isPaused: () => !1,
    cache: Ls,
    mutate: ei,
    fallback: {}
  },
  // use web preset by default
  qa
), ni = (t, e) => {
  const n = Me(t, e);
  if (e) {
    const { use: r, fallback: s } = t, { use: a, fallback: i } = e;
    r && a && (n.use = r.concat(a)), s && i && (n.fallback = Me(s, i));
  }
  return n;
}, ri = da({}), si = "$inf$", $s = Jt && window.__SWR_DEVTOOLS_USE__, ai = $s ? window.__SWR_DEVTOOLS_USE__ : [], ii = () => {
  $s && (window.__SWR_DEVTOOLS_REACT__ = Gt);
}, oi = (t) => be(t[1]) ? [
  t[0],
  t[1],
  t[2] || {}
] : [
  t[0],
  null,
  (t[1] === null ? t[2] : t[1]) || {}
], ui = () => Me(ti, ha(ri)), ci = (t) => (e, n, r) => t(e, n && ((...a) => {
  const [i] = Pr(e), [, , , o] = Pe.get(Ls);
  if (i.startsWith(si))
    return n(...a);
  const u = o[i];
  return N(u) ? n(...a) : (delete o[i], u);
}), r), di = ai.concat(ci), li = (t) => function(...n) {
  const r = ui(), [s, a, i] = oi(n), o = ni(r, i);
  let u = t;
  const { use: c } = o, h = (c || []).concat(di);
  for (let p = h.length; p--; )
    u = h[p](u);
  return u(s, a || o.fetcher || null, o);
}, fi = (t, e, n) => {
  const r = e[t] || (e[t] = []);
  return r.push(n), () => {
    const s = r.indexOf(n);
    s >= 0 && (r[s] = r[r.length - 1], r.pop());
  };
};
ii();
const Wn = Gt.use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((t) => {
  switch (t.status) {
    case "pending":
      throw t;
    case "fulfilled":
      return t.value;
    case "rejected":
      throw t.reason;
    default:
      throw t.status = "pending", t.then((e) => {
        t.status = "fulfilled", t.value = e;
      }, (e) => {
        t.status = "rejected", t.reason = e;
      }), t;
  }
}), zn = {
  dedupe: !0
}, hi = (t, e, n) => {
  const { cache: r, compare: s, suspense: a, fallbackData: i, revalidateOnMount: o, revalidateIfStale: u, refreshInterval: c, refreshWhenHidden: h, refreshWhenOffline: p, keepPreviousData: k } = n, [g, b, l, v] = Pe.get(r), [m, z] = Pr(t), R = qe(!1), q = qe(!1), D = qe(m), B = qe(e), I = qe(n), $ = () => I.current, Se = () => $().isVisible() && $().isOnline(), [M, rt, ze, le] = Ds(r, m), st = qe({}).current, Yt = N(i) ? N(n.fallback) ? ee : n.fallback[m] : i, Dr = (j, Z) => {
    for (const G in st) {
      const W = G;
      if (W === "data") {
        if (!s(j[W], Z[W]) && (!N(j[W]) || !s(en, Z[W])))
          return !1;
      } else if (Z[W] !== j[W])
        return !1;
    }
    return !0;
  }, Mr = pa(() => {
    const j = !m || !e ? !1 : N(o) ? $().isPaused() || a ? !1 : u !== !1 : o, Z = (Y) => {
      const Oe = Me(Y);
      return delete Oe._k, j ? Ue({
        isValidating: !0,
        isLoading: !0
      }, Oe) : Oe;
    }, G = M(), W = le(), ye = Z(G), ot = G === W ? ye : Z(W);
    let K = ye;
    return [
      () => {
        const Y = Z(M());
        return Dr(Y, K) ? (K.data = Y.data, K.isLoading = Y.isLoading, K.isValidating = Y.isValidating, K.error = Y.error, K) : (K = Y, Y);
      },
      () => ot
    ];
  }, [
    r,
    m
  ]), at = $a.useSyncExternalStore(an(
    (j) => ze(m, (Z, G) => {
      Dr(G, Z) || j();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      m
    ]
  ), Mr[0], Mr[1]), Lr = !R.current, ea = g[m] && g[m].length > 0, it = at.data, Ve = N(it) ? Yt && Zs(Yt) ? Wn(Yt) : Yt : it, Qt = at.error, Cn = qe(Ve), en = k ? N(it) ? N(Cn.current) ? Ve : Cn.current : it : Ve, $r = ea && !N(Qt) ? !1 : Lr && !N(o) ? o : $().isPaused() ? !1 : a ? N(Ve) ? !1 : u : N(Ve) || u, Fr = !!(m && e && Lr && $r), ta = N(at.isValidating) ? Fr : at.isValidating, na = N(at.isLoading) ? Fr : at.isLoading, wt = an(
    (j) => Be(void 0, null, function* () {
      const Z = B.current;
      if (!m || !Z || q.current || $().isPaused())
        return !1;
      let G, W, ye = !0;
      const ot = j || {}, K = !l[m] || !ot.dedupe, Y = () => ds ? !q.current && m === D.current && R.current : m === D.current, Oe = {
        isValidating: !1,
        isLoading: !1
      }, zr = () => {
        rt(Oe);
      }, Vr = () => {
        const ce = l[m];
        ce && ce[1] === W && delete l[m];
      }, Ur = {
        isValidating: !0
      };
      N(M().data) && (Ur.isLoading = !0);
      try {
        if (K && (rt(Ur), n.loadingTimeout && N(M().data) && setTimeout(() => {
          ye && Y() && $().onLoadingSlow(m, n);
        }, n.loadingTimeout), l[m] = [
          Z(z),
          pr()
        ]), [G, W] = l[m], G = yield G, K && setTimeout(Vr, n.dedupingInterval), !l[m] || l[m][1] !== W)
          return K && Y() && $().onDiscarded(m), !1;
        Oe.error = ee;
        const ce = b[m];
        if (!N(ce) && // case 1
        (W <= ce[0] || // case 2
        W <= ce[1] || // case 3
        ce[1] === 0))
          return zr(), K && Y() && $().onDiscarded(m), !1;
        const Te = M().data;
        Oe.data = s(Te, G) ? Te : G, K && Y() && $().onSuccess(G, m, n);
      } catch (ce) {
        Vr();
        const Te = $(), { shouldRetryOnError: Nn } = Te;
        Te.isPaused() || (Oe.error = ce, K && Y() && (Te.onError(ce, m, Te), (Nn === !0 || be(Nn) && Nn(ce)) && (!$().revalidateOnFocus || !$().revalidateOnReconnect || Se()) && Te.onErrorRetry(ce, m, Te, (ra) => {
          const Pn = g[m];
          Pn && Pn[0] && Pn[0](us, ra);
        }, {
          retryCount: (ot.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return ye = !1, zr(), !0;
    }),
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      m,
      r
    ]
  ), Wr = an(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...j) => Ms(r, D.current, ...j),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (Ln(() => {
    B.current = e, I.current = n, N(it) || (Cn.current = it);
  }), Ln(() => {
    if (!m) return;
    const j = wt.bind(ee, zn);
    let Z = 0;
    const W = fi(m, g, (ye, ot = {}) => {
      if (ye == Rs) {
        const K = Date.now();
        $().revalidateOnFocus && K > Z && Se() && (Z = K + $().focusThrottleInterval, j());
      } else if (ye == Is)
        $().revalidateOnReconnect && Se() && j();
      else {
        if (ye == js)
          return wt();
        if (ye == us)
          return wt(ot);
      }
    });
    return q.current = !1, D.current = m, R.current = !0, rt({
      _k: z
    }), $r && (N(Ve) || Zt ? j() : Ha(j)), () => {
      q.current = !0, W();
    };
  }, [
    m
  ]), Ln(() => {
    let j;
    function Z() {
      const W = be(c) ? c(M().data) : c;
      W && j !== -1 && (j = setTimeout(G, W));
    }
    function G() {
      !M().error && (h || $().isVisible()) && (p || $().isOnline()) ? wt(zn).then(Z) : Z();
    }
    return Z(), () => {
      j && (clearTimeout(j), j = -1);
    };
  }, [
    c,
    h,
    p,
    m
  ]), ma(en), a && N(Ve) && m) {
    if (!ds && Zt)
      throw new Error("Fallback data is required when using Suspense in SSR.");
    B.current = e, I.current = n, q.current = !1;
    const j = v[m];
    if (!N(j)) {
      const Z = Wr(j);
      Wn(Z);
    }
    if (N(Qt)) {
      const Z = wt(zn);
      N(en) || (Z.status = "fulfilled", Z.value = !0), Wn(Z);
    } else
      throw Qt;
  }
  return {
    mutate: Wr,
    get data() {
      return st.data = !0, en;
    },
    get error() {
      return st.error = !0, Qt;
    },
    get isValidating() {
      return st.isValidating = !0, ta;
    },
    get isLoading() {
      return st.isLoading = !0, na;
    }
  };
}, pi = li(hi);
var mi = Object.defineProperty, yi = Object.defineProperties, gi = Object.getOwnPropertyDescriptors, hs = Object.getOwnPropertySymbols, _i = Object.prototype.hasOwnProperty, vi = Object.prototype.propertyIsEnumerable, ps = (t, e, n) => e in t ? mi(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, d = (t, e) => {
  for (var n in e || (e = {}))
    _i.call(e, n) && ps(t, n, e[n]);
  if (hs)
    for (var n of hs(e))
      vi.call(e, n) && ps(t, n, e[n]);
  return t;
}, x = (t, e) => yi(t, gi(e)), ke = (t, e, n) => new Promise((r, s) => {
  var a = (u) => {
    try {
      o(n.next(u));
    } catch (c) {
      s(c);
    }
  }, i = (u) => {
    try {
      o(n.throw(u));
    } catch (c) {
      s(c);
    }
  }, o = (u) => u.done ? r(u.value) : Promise.resolve(u.value).then(a, i);
  o((n = n.apply(t, e)).next());
}), C;
(function(t) {
  t.assertEqual = (s) => s;
  function e(s) {
  }
  t.assertIs = e;
  function n(s) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (s) => {
    const a = {};
    for (const i of s)
      a[i] = i;
    return a;
  }, t.getValidEnumValues = (s) => {
    const a = t.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), i = {};
    for (const o of a)
      i[o] = s[o];
    return t.objectValues(i);
  }, t.objectValues = (s) => t.objectKeys(s).map(function(a) {
    return s[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const a = [];
    for (const i in s)
      Object.prototype.hasOwnProperty.call(s, i) && a.push(i);
    return a;
  }, t.find = (s, a) => {
    for (const i of s)
      if (a(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function r(s, a = " | ") {
    return s.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  t.joinValues = r, t.jsonStringifyReplacer = (s, a) => typeof a == "bigint" ? a.toString() : a;
})(C || (C = {}));
var mr;
(function(t) {
  t.mergeShapes = (e, n) => d(d({}, e), n);
})(mr || (mr = {}));
const _ = C.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Ne = (t) => {
  switch (typeof t) {
    case "undefined":
      return _.undefined;
    case "string":
      return _.string;
    case "number":
      return isNaN(t) ? _.nan : _.number;
    case "boolean":
      return _.boolean;
    case "function":
      return _.function;
    case "bigint":
      return _.bigint;
    case "symbol":
      return _.symbol;
    case "object":
      return Array.isArray(t) ? _.array : t === null ? _.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? _.promise : typeof Map != "undefined" && t instanceof Map ? _.map : typeof Set != "undefined" && t instanceof Set ? _.set : typeof Date != "undefined" && t instanceof Date ? _.date : _.object;
    default:
      return _.unknown;
  }
}, f = C.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), bi = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class ie extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const n = e || function(a) {
      return a.message;
    }, r = { _errors: [] }, s = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(s);
        else if (i.code === "invalid_return_type")
          s(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          s(i.argumentsError);
        else if (i.path.length === 0)
          r._errors.push(n(i));
        else {
          let o = r, u = 0;
          for (; u < i.path.length; ) {
            const c = i.path[u];
            u === i.path.length - 1 ? (o[c] = o[c] || { _errors: [] }, o[c]._errors.push(n(i))) : o[c] = o[c] || { _errors: [] }, o = o[c], u++;
          }
        }
    };
    return s(this), r;
  }
  static assert(e) {
    if (!(e instanceof ie))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, C.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const s of this.issues)
      s.path.length > 0 ? (n[s.path[0]] = n[s.path[0]] || [], n[s.path[0]].push(e(s))) : r.push(e(s));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
ie.create = (t) => new ie(t);
const gt = (t, e) => {
  let n;
  switch (t.code) {
    case f.invalid_type:
      t.received === _.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case f.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, C.jsonStringifyReplacer)}`;
      break;
    case f.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${C.joinValues(t.keys, ", ")}`;
      break;
    case f.invalid_union:
      n = "Invalid input";
      break;
    case f.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${C.joinValues(t.options)}`;
      break;
    case f.invalid_enum_value:
      n = `Invalid enum value. Expected ${C.joinValues(t.options)}, received '${t.received}'`;
      break;
    case f.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case f.invalid_return_type:
      n = "Invalid function return type";
      break;
    case f.invalid_date:
      n = "Invalid date";
      break;
    case f.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : C.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case f.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case f.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case f.custom:
      n = "Invalid input";
      break;
    case f.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case f.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case f.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, C.assertNever(t);
  }
  return { message: n };
};
let Fs = gt;
function wi(t) {
  Fs = t;
}
function yn() {
  return Fs;
}
const gn = (t) => {
  const { data: e, path: n, errorMaps: r, issueData: s } = t, a = [...n, ...s.path || []], i = x(d({}, s), {
    path: a
  });
  if (s.message !== void 0)
    return x(d({}, s), {
      path: a,
      message: s.message
    });
  let o = "";
  const u = r.filter((c) => !!c).slice().reverse();
  for (const c of u)
    o = c(i, { data: e, defaultError: o }).message;
  return x(d({}, s), {
    path: a,
    message: o
  });
}, ki = [];
function y(t, e) {
  const n = yn(), r = gn({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === gt ? void 0 : gt
      // then global default map
    ].filter((s) => !!s)
  });
  t.common.issues.push(r);
}
class X {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const s of n) {
      if (s.status === "aborted")
        return S;
      s.status === "dirty" && e.dirty(), r.push(s.value);
    }
    return { status: e.value, value: r };
  }
  static mergeObjectAsync(e, n) {
    return ke(this, null, function* () {
      const r = [];
      for (const s of n) {
        const a = yield s.key, i = yield s.value;
        r.push({
          key: a,
          value: i
        });
      }
      return X.mergeObjectSync(e, r);
    });
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const s of n) {
      const { key: a, value: i } = s;
      if (a.status === "aborted" || i.status === "aborted")
        return S;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value != "undefined" || s.alwaysSet) && (r[a.value] = i.value);
    }
    return { status: e.value, value: r };
  }
}
const S = Object.freeze({
  status: "aborted"
}), _n = (t) => ({ status: "dirty", value: t }), te = (t) => ({ status: "valid", value: t }), yr = (t) => t.status === "aborted", gr = (t) => t.status === "dirty", et = (t) => t.status === "valid", Dt = (t) => typeof Promise != "undefined" && t instanceof Promise;
function vn(t, e, n, r) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function Ws(t, e, n, r, s) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, n), n;
}
var w;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(w || (w = {}));
var St, Ot;
class Ee {
  constructor(e, n, r, s) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const ms = (t, e) => {
  if (et(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new ie(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function O(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: s } = t;
  if (e && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (a, i) => {
    var o, u;
    const { message: c } = t;
    return a.code === "invalid_enum_value" ? { message: c != null ? c : i.defaultError } : typeof i.data == "undefined" ? { message: (o = c != null ? c : r) !== null && o !== void 0 ? o : i.defaultError } : a.code !== "invalid_type" ? { message: i.defaultError } : { message: (u = c != null ? c : n) !== null && u !== void 0 ? u : i.defaultError };
  }, description: s };
}
class T {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Ne(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: Ne(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new X(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Ne(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (Dt(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    var r;
    const s = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ne(e)
    }, a = this._parseSync({ data: e, path: s.path, parent: s });
    return ms(s, a);
  }
  "~validate"(e) {
    var n, r;
    const s = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ne(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: s });
        return et(a) ? {
          value: a.value
        } : {
          issues: s.common.issues
        };
      } catch (a) {
        !((r = (n = a == null ? void 0 : a.message) === null || n === void 0 ? void 0 : n.toLowerCase()) === null || r === void 0) && r.includes("encountered") && (this["~standard"].async = !0), s.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: s }).then((a) => et(a) ? {
      value: a.value
    } : {
      issues: s.common.issues
    });
  }
  parseAsync(e, n) {
    return ke(this, null, function* () {
      const r = yield this.safeParseAsync(e, n);
      if (r.success)
        return r.data;
      throw r.error;
    });
  }
  safeParseAsync(e, n) {
    return ke(this, null, function* () {
      const r = {
        common: {
          issues: [],
          contextualErrorMap: n == null ? void 0 : n.errorMap,
          async: !0
        },
        path: (n == null ? void 0 : n.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: e,
        parsedType: Ne(e)
      }, s = this._parse({ data: e, path: r.path, parent: r }), a = yield Dt(s) ? s : Promise.resolve(s);
      return ms(r, a);
    });
  }
  refine(e, n) {
    const r = (s) => typeof n == "string" || typeof n == "undefined" ? { message: n } : typeof n == "function" ? n(s) : n;
    return this._refinement((s, a) => {
      const i = e(s), o = () => a.addIssue(d({
        code: f.custom
      }, r(s)));
      return typeof Promise != "undefined" && i instanceof Promise ? i.then((u) => u ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, s) => e(r) ? !0 : (s.addIssue(typeof n == "function" ? n(r, s) : n), !1));
  }
  _refinement(e) {
    return new me({
      schema: this,
      typeName: E.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return we.create(this, this._def);
  }
  nullable() {
    return We.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return pe.create(this);
  }
  promise() {
    return vt.create(this, this._def);
  }
  or(e) {
    return Ft.create([this, e], this._def);
  }
  and(e) {
    return Wt.create(this, e, this._def);
  }
  transform(e) {
    return new me(x(d({}, O(this._def)), {
      schema: this,
      typeName: E.ZodEffects,
      effect: { type: "transform", transform: e }
    }));
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new qt(x(d({}, O(this._def)), {
      innerType: this,
      defaultValue: n,
      typeName: E.ZodDefault
    }));
  }
  brand() {
    return new Rr(d({
      typeName: E.ZodBranded,
      type: this
    }, O(this._def)));
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Kt(x(d({}, O(this._def)), {
      innerType: this,
      catchValue: n,
      typeName: E.ZodCatch
    }));
  }
  describe(e) {
    const n = this.constructor;
    return new n(x(d({}, this._def), {
      description: e
    }));
  }
  pipe(e) {
    return Xt.create(this, e);
  }
  readonly() {
    return Ht.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Ei = /^c[^\s-]{8,}$/i, xi = /^[0-9a-z]+$/, Si = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Oi = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ti = /^[a-z0-9_-]{21}$/i, Ai = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Ci = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Ni = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Pi = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Vn;
const Ri = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ii = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, ji = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Zi = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Di = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Mi = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, zs = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Li = new RegExp(`^${zs}$`);
function Vs(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function $i(t) {
  return new RegExp(`^${Vs(t)}$`);
}
function Us(t) {
  let e = `${zs}T${Vs(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function Fi(t, e) {
  return !!((e === "v4" || !e) && Ri.test(t) || (e === "v6" || !e) && ji.test(t));
}
function Wi(t, e) {
  if (!Ai.test(t))
    return !1;
  try {
    const [n] = t.split("."), r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), s = JSON.parse(atob(r));
    return !(typeof s != "object" || s === null || !s.typ || !s.alg || e && s.alg !== e);
  } catch (n) {
    return !1;
  }
}
function zi(t, e) {
  return !!((e === "v4" || !e) && Ii.test(t) || (e === "v6" || !e) && Zi.test(t));
}
class he extends T {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== _.string) {
      const s = this._getOrReturnCtx(e);
      return y(s, {
        code: f.invalid_type,
        expected: _.string,
        received: s.parsedType
      }), S;
    }
    const n = new X();
    let r;
    for (const s of this._def.checks)
      if (s.kind === "min")
        e.data.length < s.value && (r = this._getOrReturnCtx(e, r), y(r, {
          code: f.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        e.data.length > s.value && (r = this._getOrReturnCtx(e, r), y(r, {
          code: f.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const a = e.data.length > s.value, i = e.data.length < s.value;
        (a || i) && (r = this._getOrReturnCtx(e, r), a ? y(r, {
          code: f.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : i && y(r, {
          code: f.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        Ni.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
          validation: "email",
          code: f.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        Vn || (Vn = new RegExp(Pi, "u")), Vn.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
          validation: "emoji",
          code: f.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        Oi.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
          validation: "uuid",
          code: f.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        Ti.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
          validation: "nanoid",
          code: f.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        Ei.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
          validation: "cuid",
          code: f.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        xi.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
          validation: "cuid2",
          code: f.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        Si.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
          validation: "ulid",
          code: f.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(e.data);
        } catch (a) {
          r = this._getOrReturnCtx(e, r), y(r, {
            validation: "url",
            code: f.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
        validation: "regex",
        code: f.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? e.data = e.data.trim() : s.kind === "includes" ? e.data.includes(s.value, s.position) || (r = this._getOrReturnCtx(e, r), y(r, {
        code: f.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : s.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : s.kind === "startsWith" ? e.data.startsWith(s.value) || (r = this._getOrReturnCtx(e, r), y(r, {
        code: f.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? e.data.endsWith(s.value) || (r = this._getOrReturnCtx(e, r), y(r, {
        code: f.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? Us(s).test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
        code: f.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? Li.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
        code: f.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? $i(s).test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
        code: f.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? Ci.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
        validation: "duration",
        code: f.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? Fi(e.data, s.version) || (r = this._getOrReturnCtx(e, r), y(r, {
        validation: "ip",
        code: f.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? Wi(e.data, s.alg) || (r = this._getOrReturnCtx(e, r), y(r, {
        validation: "jwt",
        code: f.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? zi(e.data, s.version) || (r = this._getOrReturnCtx(e, r), y(r, {
        validation: "cidr",
        code: f.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? Di.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
        validation: "base64",
        code: f.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? Mi.test(e.data) || (r = this._getOrReturnCtx(e, r), y(r, {
        validation: "base64url",
        code: f.invalid_string,
        message: s.message
      }), n.dirty()) : C.assertNever(s);
    return { status: n.value, value: e.data };
  }
  _regex(e, n, r) {
    return this.refinement((s) => e.test(s), d({
      validation: n,
      code: f.invalid_string
    }, w.errToObj(r)));
  }
  _addCheck(e) {
    return new he(x(d({}, this._def), {
      checks: [...this._def.checks, e]
    }));
  }
  email(e) {
    return this._addCheck(d({ kind: "email" }, w.errToObj(e)));
  }
  url(e) {
    return this._addCheck(d({ kind: "url" }, w.errToObj(e)));
  }
  emoji(e) {
    return this._addCheck(d({ kind: "emoji" }, w.errToObj(e)));
  }
  uuid(e) {
    return this._addCheck(d({ kind: "uuid" }, w.errToObj(e)));
  }
  nanoid(e) {
    return this._addCheck(d({ kind: "nanoid" }, w.errToObj(e)));
  }
  cuid(e) {
    return this._addCheck(d({ kind: "cuid" }, w.errToObj(e)));
  }
  cuid2(e) {
    return this._addCheck(d({ kind: "cuid2" }, w.errToObj(e)));
  }
  ulid(e) {
    return this._addCheck(d({ kind: "ulid" }, w.errToObj(e)));
  }
  base64(e) {
    return this._addCheck(d({ kind: "base64" }, w.errToObj(e)));
  }
  base64url(e) {
    return this._addCheck(d({
      kind: "base64url"
    }, w.errToObj(e)));
  }
  jwt(e) {
    return this._addCheck(d({ kind: "jwt" }, w.errToObj(e)));
  }
  ip(e) {
    return this._addCheck(d({ kind: "ip" }, w.errToObj(e)));
  }
  cidr(e) {
    return this._addCheck(d({ kind: "cidr" }, w.errToObj(e)));
  }
  datetime(e) {
    var n, r;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck(d({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) == "undefined" ? null : e == null ? void 0 : e.precision,
      offset: (n = e == null ? void 0 : e.offset) !== null && n !== void 0 ? n : !1,
      local: (r = e == null ? void 0 : e.local) !== null && r !== void 0 ? r : !1
    }, w.errToObj(e == null ? void 0 : e.message)));
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck(d({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) == "undefined" ? null : e == null ? void 0 : e.precision
    }, w.errToObj(e == null ? void 0 : e.message)));
  }
  duration(e) {
    return this._addCheck(d({ kind: "duration" }, w.errToObj(e)));
  }
  regex(e, n) {
    return this._addCheck(d({
      kind: "regex",
      regex: e
    }, w.errToObj(n)));
  }
  includes(e, n) {
    return this._addCheck(d({
      kind: "includes",
      value: e,
      position: n == null ? void 0 : n.position
    }, w.errToObj(n == null ? void 0 : n.message)));
  }
  startsWith(e, n) {
    return this._addCheck(d({
      kind: "startsWith",
      value: e
    }, w.errToObj(n)));
  }
  endsWith(e, n) {
    return this._addCheck(d({
      kind: "endsWith",
      value: e
    }, w.errToObj(n)));
  }
  min(e, n) {
    return this._addCheck(d({
      kind: "min",
      value: e
    }, w.errToObj(n)));
  }
  max(e, n) {
    return this._addCheck(d({
      kind: "max",
      value: e
    }, w.errToObj(n)));
  }
  length(e, n) {
    return this._addCheck(d({
      kind: "length",
      value: e
    }, w.errToObj(n)));
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, w.errToObj(e));
  }
  trim() {
    return new he(x(d({}, this._def), {
      checks: [...this._def.checks, { kind: "trim" }]
    }));
  }
  toLowerCase() {
    return new he(x(d({}, this._def), {
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }));
  }
  toUpperCase() {
    return new he(x(d({}, this._def), {
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    }));
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
he.create = (t) => {
  var e;
  return new he(d({
    checks: [],
    typeName: E.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1
  }, O(t)));
};
function Vi(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = n > r ? n : r, a = parseInt(t.toFixed(s).replace(".", "")), i = parseInt(e.toFixed(s).replace(".", ""));
  return a % i / Math.pow(10, s);
}
class Le extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== _.number) {
      const s = this._getOrReturnCtx(e);
      return y(s, {
        code: f.invalid_type,
        expected: _.number,
        received: s.parsedType
      }), S;
    }
    let n;
    const r = new X();
    for (const s of this._def.checks)
      s.kind === "int" ? C.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), y(n, {
        code: f.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), r.dirty()) : s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: f.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), r.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: f.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), r.dirty()) : s.kind === "multipleOf" ? Vi(e.data, s.value) !== 0 && (n = this._getOrReturnCtx(e, n), y(n, {
        code: f.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), r.dirty()) : s.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), y(n, {
        code: f.not_finite,
        message: s.message
      }), r.dirty()) : C.assertNever(s);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, w.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, w.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, w.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, w.toString(n));
  }
  setLimit(e, n, r, s) {
    return new Le(x(d({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: w.toString(s)
        }
      ]
    }));
  }
  _addCheck(e) {
    return new Le(x(d({}, this._def), {
      checks: [...this._def.checks, e]
    }));
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: w.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: w.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: w.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: w.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: w.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: w.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: w.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: w.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: w.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && C.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
Le.create = (t) => new Le(d({
  checks: [],
  typeName: E.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1
}, O(t)));
class $e extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch (s) {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== _.bigint)
      return this._getInvalidInput(e);
    let n;
    const r = new X();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: f.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), r.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: f.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), r.dirty()) : s.kind === "multipleOf" ? e.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: f.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), r.dirty()) : C.assertNever(s);
    return { status: r.value, value: e.data };
  }
  _getInvalidInput(e) {
    const n = this._getOrReturnCtx(e);
    return y(n, {
      code: f.invalid_type,
      expected: _.bigint,
      received: n.parsedType
    }), S;
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, w.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, w.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, w.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, w.toString(n));
  }
  setLimit(e, n, r, s) {
    return new $e(x(d({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: w.toString(s)
        }
      ]
    }));
  }
  _addCheck(e) {
    return new $e(x(d({}, this._def), {
      checks: [...this._def.checks, e]
    }));
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: w.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: w.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: w.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: w.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: w.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
$e.create = (t) => {
  var e;
  return new $e(d({
    checks: [],
    typeName: E.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1
  }, O(t)));
};
class Mt extends T {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== _.boolean) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: f.invalid_type,
        expected: _.boolean,
        received: n.parsedType
      }), S;
    }
    return te(e.data);
  }
}
Mt.create = (t) => new Mt(d({
  typeName: E.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1
}, O(t)));
class tt extends T {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== _.date) {
      const s = this._getOrReturnCtx(e);
      return y(s, {
        code: f.invalid_type,
        expected: _.date,
        received: s.parsedType
      }), S;
    }
    if (isNaN(e.data.getTime())) {
      const s = this._getOrReturnCtx(e);
      return y(s, {
        code: f.invalid_date
      }), S;
    }
    const n = new X();
    let r;
    for (const s of this._def.checks)
      s.kind === "min" ? e.data.getTime() < s.value && (r = this._getOrReturnCtx(e, r), y(r, {
        code: f.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? e.data.getTime() > s.value && (r = this._getOrReturnCtx(e, r), y(r, {
        code: f.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : C.assertNever(s);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new tt(x(d({}, this._def), {
      checks: [...this._def.checks, e]
    }));
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: w.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: w.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
tt.create = (t) => new tt(d({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: E.ZodDate
}, O(t)));
class bn extends T {
  _parse(e) {
    if (this._getType(e) !== _.symbol) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: f.invalid_type,
        expected: _.symbol,
        received: n.parsedType
      }), S;
    }
    return te(e.data);
  }
}
bn.create = (t) => new bn(d({
  typeName: E.ZodSymbol
}, O(t)));
class Lt extends T {
  _parse(e) {
    if (this._getType(e) !== _.undefined) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: f.invalid_type,
        expected: _.undefined,
        received: n.parsedType
      }), S;
    }
    return te(e.data);
  }
}
Lt.create = (t) => new Lt(d({
  typeName: E.ZodUndefined
}, O(t)));
class $t extends T {
  _parse(e) {
    if (this._getType(e) !== _.null) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: f.invalid_type,
        expected: _.null,
        received: n.parsedType
      }), S;
    }
    return te(e.data);
  }
}
$t.create = (t) => new $t(d({
  typeName: E.ZodNull
}, O(t)));
class _t extends T {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return te(e.data);
  }
}
_t.create = (t) => new _t(d({
  typeName: E.ZodAny
}, O(t)));
class Xe extends T {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return te(e.data);
  }
}
Xe.create = (t) => new Xe(d({
  typeName: E.ZodUnknown
}, O(t)));
class Re extends T {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return y(n, {
      code: f.invalid_type,
      expected: _.never,
      received: n.parsedType
    }), S;
  }
}
Re.create = (t) => new Re(d({
  typeName: E.ZodNever
}, O(t)));
class wn extends T {
  _parse(e) {
    if (this._getType(e) !== _.undefined) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: f.invalid_type,
        expected: _.void,
        received: n.parsedType
      }), S;
    }
    return te(e.data);
  }
}
wn.create = (t) => new wn(d({
  typeName: E.ZodVoid
}, O(t)));
class pe extends T {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), s = this._def;
    if (n.parsedType !== _.array)
      return y(n, {
        code: f.invalid_type,
        expected: _.array,
        received: n.parsedType
      }), S;
    if (s.exactLength !== null) {
      const i = n.data.length > s.exactLength.value, o = n.data.length < s.exactLength.value;
      (i || o) && (y(n, {
        code: i ? f.too_big : f.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: i ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), r.dirty());
    }
    if (s.minLength !== null && n.data.length < s.minLength.value && (y(n, {
      code: f.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), r.dirty()), s.maxLength !== null && n.data.length > s.maxLength.value && (y(n, {
      code: f.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((i, o) => s.type._parseAsync(new Ee(n, i, n.path, o)))).then((i) => X.mergeArray(r, i));
    const a = [...n.data].map((i, o) => s.type._parseSync(new Ee(n, i, n.path, o)));
    return X.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new pe(x(d({}, this._def), {
      minLength: { value: e, message: w.toString(n) }
    }));
  }
  max(e, n) {
    return new pe(x(d({}, this._def), {
      maxLength: { value: e, message: w.toString(n) }
    }));
  }
  length(e, n) {
    return new pe(x(d({}, this._def), {
      exactLength: { value: e, message: w.toString(n) }
    }));
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
pe.create = (t, e) => new pe(d({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: E.ZodArray
}, O(e)));
function lt(t) {
  if (t instanceof F) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = we.create(lt(r));
    }
    return new F(x(d({}, t._def), {
      shape: () => e
    }));
  } else return t instanceof pe ? new pe(x(d({}, t._def), {
    type: lt(t.element)
  })) : t instanceof we ? we.create(lt(t.unwrap())) : t instanceof We ? We.create(lt(t.unwrap())) : t instanceof xe ? xe.create(t.items.map((e) => lt(e))) : t;
}
class F extends T {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = C.objectKeys(e);
    return this._cached = { shape: e, keys: n };
  }
  _parse(e) {
    if (this._getType(e) !== _.object) {
      const u = this._getOrReturnCtx(e);
      return y(u, {
        code: f.invalid_type,
        expected: _.object,
        received: u.parsedType
      }), S;
    }
    const { status: n, ctx: r } = this._processInputParams(e), { shape: s, keys: a } = this._getCached(), i = [];
    if (!(this._def.catchall instanceof Re && this._def.unknownKeys === "strip"))
      for (const u in r.data)
        a.includes(u) || i.push(u);
    const o = [];
    for (const u of a) {
      const c = s[u], h = r.data[u];
      o.push({
        key: { status: "valid", value: u },
        value: c._parse(new Ee(r, h, r.path, u)),
        alwaysSet: u in r.data
      });
    }
    if (this._def.catchall instanceof Re) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const c of i)
          o.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: r.data[c] }
          });
      else if (u === "strict")
        i.length > 0 && (y(r, {
          code: f.unrecognized_keys,
          keys: i
        }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of i) {
        const h = r.data[c];
        o.push({
          key: { status: "valid", value: c },
          value: u._parse(
            new Ee(r, h, r.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(() => ke(this, null, function* () {
      const u = [];
      for (const c of o) {
        const h = yield c.key, p = yield c.value;
        u.push({
          key: h,
          value: p,
          alwaysSet: c.alwaysSet
        });
      }
      return u;
    })).then((u) => X.mergeObjectSync(n, u)) : X.mergeObjectSync(n, o);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return w.errToObj, new F(d(x(d({}, this._def), {
      unknownKeys: "strict"
    }), e !== void 0 ? {
      errorMap: (n, r) => {
        var s, a, i, o;
        const u = (i = (a = (s = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(s, n, r).message) !== null && i !== void 0 ? i : r.defaultError;
        return n.code === "unrecognized_keys" ? {
          message: (o = w.errToObj(e).message) !== null && o !== void 0 ? o : u
        } : {
          message: u
        };
      }
    } : {}));
  }
  strip() {
    return new F(x(d({}, this._def), {
      unknownKeys: "strip"
    }));
  }
  passthrough() {
    return new F(x(d({}, this._def), {
      unknownKeys: "passthrough"
    }));
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new F(x(d({}, this._def), {
      shape: () => d(d({}, this._def.shape()), e)
    }));
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new F({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => d(d({}, this._def.shape()), e._def.shape()),
      typeName: E.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new F(x(d({}, this._def), {
      catchall: e
    }));
  }
  pick(e) {
    const n = {};
    return C.objectKeys(e).forEach((r) => {
      e[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new F(x(d({}, this._def), {
      shape: () => n
    }));
  }
  omit(e) {
    const n = {};
    return C.objectKeys(this.shape).forEach((r) => {
      e[r] || (n[r] = this.shape[r]);
    }), new F(x(d({}, this._def), {
      shape: () => n
    }));
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return lt(this);
  }
  partial(e) {
    const n = {};
    return C.objectKeys(this.shape).forEach((r) => {
      const s = this.shape[r];
      e && !e[r] ? n[r] = s : n[r] = s.optional();
    }), new F(x(d({}, this._def), {
      shape: () => n
    }));
  }
  required(e) {
    const n = {};
    return C.objectKeys(this.shape).forEach((r) => {
      if (e && !e[r])
        n[r] = this.shape[r];
      else {
        let s = this.shape[r];
        for (; s instanceof we; )
          s = s._def.innerType;
        n[r] = s;
      }
    }), new F(x(d({}, this._def), {
      shape: () => n
    }));
  }
  keyof() {
    return Bs(C.objectKeys(this.shape));
  }
}
F.create = (t, e) => new F(d({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Re.create(),
  typeName: E.ZodObject
}, O(e)));
F.strictCreate = (t, e) => new F(d({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Re.create(),
  typeName: E.ZodObject
}, O(e)));
F.lazycreate = (t, e) => new F(d({
  shape: t,
  unknownKeys: "strip",
  catchall: Re.create(),
  typeName: E.ZodObject
}, O(e)));
class Ft extends T {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    function s(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return n.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new ie(o.ctx.common.issues));
      return y(n, {
        code: f.invalid_union,
        unionErrors: i
      }), S;
    }
    if (n.common.async)
      return Promise.all(r.map((a) => ke(this, null, function* () {
        const i = x(d({}, n), {
          common: x(d({}, n.common), {
            issues: []
          }),
          parent: null
        });
        return {
          result: yield a._parseAsync({
            data: n.data,
            path: n.path,
            parent: i
          }),
          ctx: i
        };
      }))).then(s);
    {
      let a;
      const i = [];
      for (const u of r) {
        const c = x(d({}, n), {
          common: x(d({}, n.common), {
            issues: []
          }),
          parent: null
        }), h = u._parseSync({
          data: n.data,
          path: n.path,
          parent: c
        });
        if (h.status === "valid")
          return h;
        h.status === "dirty" && !a && (a = { result: h, ctx: c }), c.common.issues.length && i.push(c.common.issues);
      }
      if (a)
        return n.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((u) => new ie(u));
      return y(n, {
        code: f.invalid_union,
        unionErrors: o
      }), S;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ft.create = (t, e) => new Ft(d({
  options: t,
  typeName: E.ZodUnion
}, O(e)));
const Ie = (t) => t instanceof Vt ? Ie(t.schema) : t instanceof me ? Ie(t.innerType()) : t instanceof Ut ? [t.value] : t instanceof Fe ? t.options : t instanceof Bt ? C.objectValues(t.enum) : t instanceof qt ? Ie(t._def.innerType) : t instanceof Lt ? [void 0] : t instanceof $t ? [null] : t instanceof we ? [void 0, ...Ie(t.unwrap())] : t instanceof We ? [null, ...Ie(t.unwrap())] : t instanceof Rr || t instanceof Ht ? Ie(t.unwrap()) : t instanceof Kt ? Ie(t._def.innerType) : [];
class An extends T {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== _.object)
      return y(n, {
        code: f.invalid_type,
        expected: _.object,
        received: n.parsedType
      }), S;
    const r = this.discriminator, s = n.data[r], a = this.optionsMap.get(s);
    return a ? n.common.async ? a._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : a._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (y(n, {
      code: f.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), S);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, r) {
    const s = /* @__PURE__ */ new Map();
    for (const a of n) {
      const i = Ie(a.shape[e]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (s.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        s.set(o, a);
      }
    }
    return new An(d({
      typeName: E.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: s
    }, O(r)));
  }
}
function _r(t, e) {
  const n = Ne(t), r = Ne(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === _.object && r === _.object) {
    const s = C.objectKeys(e), a = C.objectKeys(t).filter((o) => s.indexOf(o) !== -1), i = d(d({}, t), e);
    for (const o of a) {
      const u = _r(t[o], e[o]);
      if (!u.valid)
        return { valid: !1 };
      i[o] = u.data;
    }
    return { valid: !0, data: i };
  } else if (n === _.array && r === _.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let a = 0; a < t.length; a++) {
      const i = t[a], o = e[a], u = _r(i, o);
      if (!u.valid)
        return { valid: !1 };
      s.push(u.data);
    }
    return { valid: !0, data: s };
  } else return n === _.date && r === _.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class Wt extends T {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = (a, i) => {
      if (yr(a) || yr(i))
        return S;
      const o = _r(a.value, i.value);
      return o.valid ? ((gr(a) || gr(i)) && n.dirty(), { status: n.value, value: o.data }) : (y(r, {
        code: f.invalid_intersection_types
      }), S);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, i]) => s(a, i)) : s(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Wt.create = (t, e, n) => new Wt(d({
  left: t,
  right: e,
  typeName: E.ZodIntersection
}, O(n)));
class xe extends T {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== _.array)
      return y(r, {
        code: f.invalid_type,
        expected: _.array,
        received: r.parsedType
      }), S;
    if (r.data.length < this._def.items.length)
      return y(r, {
        code: f.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), S;
    !this._def.rest && r.data.length > this._def.items.length && (y(r, {
      code: f.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const s = [...r.data].map((a, i) => {
      const o = this._def.items[i] || this._def.rest;
      return o ? o._parse(new Ee(r, a, r.path, i)) : null;
    }).filter((a) => !!a);
    return r.common.async ? Promise.all(s).then((a) => X.mergeArray(n, a)) : X.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new xe(x(d({}, this._def), {
      rest: e
    }));
  }
}
xe.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new xe(d({
    items: t,
    typeName: E.ZodTuple,
    rest: null
  }, O(e)));
};
class zt extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== _.object)
      return y(r, {
        code: f.invalid_type,
        expected: _.object,
        received: r.parsedType
      }), S;
    const s = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in r.data)
      s.push({
        key: a._parse(new Ee(r, o, r.path, o)),
        value: i._parse(new Ee(r, r.data[o], r.path, o)),
        alwaysSet: o in r.data
      });
    return r.common.async ? X.mergeObjectAsync(n, s) : X.mergeObjectSync(n, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return n instanceof T ? new zt(d({
      keyType: e,
      valueType: n,
      typeName: E.ZodRecord
    }, O(r))) : new zt(d({
      keyType: he.create(),
      valueType: e,
      typeName: E.ZodRecord
    }, O(n)));
  }
}
class kn extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== _.map)
      return y(r, {
        code: f.invalid_type,
        expected: _.map,
        received: r.parsedType
      }), S;
    const s = this._def.keyType, a = this._def.valueType, i = [...r.data.entries()].map(([o, u], c) => ({
      key: s._parse(new Ee(r, o, r.path, [c, "key"])),
      value: a._parse(new Ee(r, u, r.path, [c, "value"]))
    }));
    if (r.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(() => ke(this, null, function* () {
        for (const u of i) {
          const c = yield u.key, h = yield u.value;
          if (c.status === "aborted" || h.status === "aborted")
            return S;
          (c.status === "dirty" || h.status === "dirty") && n.dirty(), o.set(c.value, h.value);
        }
        return { status: n.value, value: o };
      }));
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const u of i) {
        const c = u.key, h = u.value;
        if (c.status === "aborted" || h.status === "aborted")
          return S;
        (c.status === "dirty" || h.status === "dirty") && n.dirty(), o.set(c.value, h.value);
      }
      return { status: n.value, value: o };
    }
  }
}
kn.create = (t, e, n) => new kn(d({
  valueType: e,
  keyType: t,
  typeName: E.ZodMap
}, O(n)));
class nt extends T {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== _.set)
      return y(r, {
        code: f.invalid_type,
        expected: _.set,
        received: r.parsedType
      }), S;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (y(r, {
      code: f.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), n.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (y(r, {
      code: f.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), n.dirty());
    const a = this._def.valueType;
    function i(u) {
      const c = /* @__PURE__ */ new Set();
      for (const h of u) {
        if (h.status === "aborted")
          return S;
        h.status === "dirty" && n.dirty(), c.add(h.value);
      }
      return { status: n.value, value: c };
    }
    const o = [...r.data.values()].map((u, c) => a._parse(new Ee(r, u, r.path, c)));
    return r.common.async ? Promise.all(o).then((u) => i(u)) : i(o);
  }
  min(e, n) {
    return new nt(x(d({}, this._def), {
      minSize: { value: e, message: w.toString(n) }
    }));
  }
  max(e, n) {
    return new nt(x(d({}, this._def), {
      maxSize: { value: e, message: w.toString(n) }
    }));
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
nt.create = (t, e) => new nt(d({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: E.ZodSet
}, O(e)));
class pt extends T {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== _.function)
      return y(n, {
        code: f.invalid_type,
        expected: _.function,
        received: n.parsedType
      }), S;
    function r(o, u) {
      return gn({
        data: o,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          yn(),
          gt
        ].filter((c) => !!c),
        issueData: {
          code: f.invalid_arguments,
          argumentsError: u
        }
      });
    }
    function s(o, u) {
      return gn({
        data: o,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          yn(),
          gt
        ].filter((c) => !!c),
        issueData: {
          code: f.invalid_return_type,
          returnTypeError: u
        }
      });
    }
    const a = { errorMap: n.common.contextualErrorMap }, i = n.data;
    if (this._def.returns instanceof vt) {
      const o = this;
      return te(function(...u) {
        return ke(this, null, function* () {
          const c = new ie([]), h = yield o._def.args.parseAsync(u, a).catch((k) => {
            throw c.addIssue(r(u, k)), c;
          }), p = yield Reflect.apply(i, this, h);
          return yield o._def.returns._def.type.parseAsync(p, a).catch((k) => {
            throw c.addIssue(s(p, k)), c;
          });
        });
      });
    } else {
      const o = this;
      return te(function(...u) {
        const c = o._def.args.safeParse(u, a);
        if (!c.success)
          throw new ie([r(u, c.error)]);
        const h = Reflect.apply(i, this, c.data), p = o._def.returns.safeParse(h, a);
        if (!p.success)
          throw new ie([s(h, p.error)]);
        return p.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new pt(x(d({}, this._def), {
      args: xe.create(e).rest(Xe.create())
    }));
  }
  returns(e) {
    return new pt(x(d({}, this._def), {
      returns: e
    }));
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, n, r) {
    return new pt(d({
      args: e || xe.create([]).rest(Xe.create()),
      returns: n || Xe.create(),
      typeName: E.ZodFunction
    }, O(r)));
  }
}
class Vt extends T {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Vt.create = (t, e) => new Vt(d({
  getter: t,
  typeName: E.ZodLazy
}, O(e)));
class Ut extends T {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        received: n.data,
        code: f.invalid_literal,
        expected: this._def.value
      }), S;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Ut.create = (t, e) => new Ut(d({
  value: t,
  typeName: E.ZodLiteral
}, O(e)));
function Bs(t, e) {
  return new Fe(d({
    values: t,
    typeName: E.ZodEnum
  }, O(e)));
}
class Fe extends T {
  constructor() {
    super(...arguments), St.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return y(n, {
        expected: C.joinValues(r),
        received: n.parsedType,
        code: f.invalid_type
      }), S;
    }
    if (vn(this, St) || Ws(this, St, new Set(this._def.values)), !vn(this, St).has(e.data)) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return y(n, {
        received: n.data,
        code: f.invalid_enum_value,
        options: r
      }), S;
    }
    return te(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return Fe.create(e, d(d({}, this._def), n));
  }
  exclude(e, n = this._def) {
    return Fe.create(this.options.filter((r) => !e.includes(r)), d(d({}, this._def), n));
  }
}
St = /* @__PURE__ */ new WeakMap();
Fe.create = Bs;
class Bt extends T {
  constructor() {
    super(...arguments), Ot.set(this, void 0);
  }
  _parse(e) {
    const n = C.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== _.string && r.parsedType !== _.number) {
      const s = C.objectValues(n);
      return y(r, {
        expected: C.joinValues(s),
        received: r.parsedType,
        code: f.invalid_type
      }), S;
    }
    if (vn(this, Ot) || Ws(this, Ot, new Set(C.getValidEnumValues(this._def.values))), !vn(this, Ot).has(e.data)) {
      const s = C.objectValues(n);
      return y(r, {
        received: r.data,
        code: f.invalid_enum_value,
        options: s
      }), S;
    }
    return te(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ot = /* @__PURE__ */ new WeakMap();
Bt.create = (t, e) => new Bt(d({
  values: t,
  typeName: E.ZodNativeEnum
}, O(e)));
class vt extends T {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== _.promise && n.common.async === !1)
      return y(n, {
        code: f.invalid_type,
        expected: _.promise,
        received: n.parsedType
      }), S;
    const r = n.parsedType === _.promise ? n.data : Promise.resolve(n.data);
    return te(r.then((s) => this._def.type.parseAsync(s, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
vt.create = (t, e) => new vt(d({
  type: t,
  typeName: E.ZodPromise
}, O(e)));
class me extends T {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === E.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = this._def.effect || null, a = {
      addIssue: (i) => {
        y(r, i), i.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), s.type === "preprocess") {
      const i = s.transform(r.data, a);
      if (r.common.async)
        return Promise.resolve(i).then((o) => ke(this, null, function* () {
          if (n.value === "aborted")
            return S;
          const u = yield this._def.schema._parseAsync({
            data: o,
            path: r.path,
            parent: r
          });
          return u.status === "aborted" ? S : u.status === "dirty" || n.value === "dirty" ? _n(u.value) : u;
        }));
      {
        if (n.value === "aborted")
          return S;
        const o = this._def.schema._parseSync({
          data: i,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? S : o.status === "dirty" || n.value === "dirty" ? _n(o.value) : o;
      }
    }
    if (s.type === "refinement") {
      const i = (o) => {
        const u = s.refinement(o, a);
        if (r.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? S : (o.status === "dirty" && n.dirty(), i(o.value), { status: n.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => o.status === "aborted" ? S : (o.status === "dirty" && n.dirty(), i(o.value).then(() => ({ status: n.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (r.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!et(i))
          return i;
        const o = s.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((i) => et(i) ? Promise.resolve(s.transform(i.value, a)).then((o) => ({ status: n.value, value: o })) : i);
    C.assertNever(s);
  }
}
me.create = (t, e, n) => new me(d({
  schema: t,
  typeName: E.ZodEffects,
  effect: e
}, O(n)));
me.createWithPreprocess = (t, e, n) => new me(d({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: E.ZodEffects
}, O(n)));
class we extends T {
  _parse(e) {
    return this._getType(e) === _.undefined ? te(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
we.create = (t, e) => new we(d({
  innerType: t,
  typeName: E.ZodOptional
}, O(e)));
class We extends T {
  _parse(e) {
    return this._getType(e) === _.null ? te(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
We.create = (t, e) => new We(d({
  innerType: t,
  typeName: E.ZodNullable
}, O(e)));
class qt extends T {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === _.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
qt.create = (t, e) => new qt(d({
  innerType: t,
  typeName: E.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default
}, O(e)));
class Kt extends T {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = x(d({}, n), {
      common: x(d({}, n.common), {
        issues: []
      })
    }), s = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: d({}, r)
    });
    return Dt(s) ? s.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new ie(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new ie(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Kt.create = (t, e) => new Kt(d({
  innerType: t,
  typeName: E.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch
}, O(e)));
class En extends T {
  _parse(e) {
    if (this._getType(e) !== _.nan) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: f.invalid_type,
        expected: _.nan,
        received: n.parsedType
      }), S;
    }
    return { status: "valid", value: e.data };
  }
}
En.create = (t) => new En(d({
  typeName: E.ZodNaN
}, O(t)));
const Ui = Symbol("zod_brand");
class Rr extends T {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Xt extends T {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return ke(this, null, function* () {
        const s = yield this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? S : s.status === "dirty" ? (n.dirty(), _n(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: r.path,
          parent: r
        });
      });
    {
      const s = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return s.status === "aborted" ? S : s.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, n) {
    return new Xt({
      in: e,
      out: n,
      typeName: E.ZodPipeline
    });
  }
}
class Ht extends T {
  _parse(e) {
    const n = this._def.innerType._parse(e), r = (s) => (et(s) && (s.value = Object.freeze(s.value)), s);
    return Dt(n) ? n.then((s) => r(s)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ht.create = (t, e) => new Ht(d({
  innerType: t,
  typeName: E.ZodReadonly
}, O(e)));
function qs(t, e = {}, n) {
  return t ? _t.create().superRefine((r, s) => {
    var a, i;
    if (!t(r)) {
      const o = typeof e == "function" ? e(r) : typeof e == "string" ? { message: e } : e, u = (i = (a = o.fatal) !== null && a !== void 0 ? a : n) !== null && i !== void 0 ? i : !0, c = typeof o == "string" ? { message: o } : o;
      s.addIssue(x(d({ code: "custom" }, c), { fatal: u }));
    }
  }) : _t.create();
}
const Bi = {
  object: F.lazycreate
};
var E;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(E || (E = {}));
const qi = (t, e = {
  message: `Input not instance of ${t.name}`
}) => qs((n) => n instanceof t, e), Ks = he.create, Hs = Le.create, Ki = En.create, Hi = $e.create, Gs = Mt.create, Gi = tt.create, Ji = bn.create, Xi = Lt.create, Yi = $t.create, Qi = _t.create, eo = Xe.create, to = Re.create, no = wn.create, ro = pe.create, so = F.create, ao = F.strictCreate, io = Ft.create, oo = An.create, uo = Wt.create, co = xe.create, lo = zt.create, fo = kn.create, ho = nt.create, po = pt.create, mo = Vt.create, yo = Ut.create, go = Fe.create, _o = Bt.create, vo = vt.create, ys = me.create, bo = we.create, wo = We.create, ko = me.createWithPreprocess, Eo = Xt.create, xo = () => Ks().optional(), So = () => Hs().optional(), Oo = () => Gs().optional(), To = {
  string: (t) => he.create(x(d({}, t), { coerce: !0 })),
  number: (t) => Le.create(x(d({}, t), { coerce: !0 })),
  boolean: (t) => Mt.create(x(d({}, t), {
    coerce: !0
  })),
  bigint: (t) => $e.create(x(d({}, t), { coerce: !0 })),
  date: (t) => tt.create(x(d({}, t), { coerce: !0 }))
}, Ao = S;
var H = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: gt,
  setErrorMap: wi,
  getErrorMap: yn,
  makeIssue: gn,
  EMPTY_PATH: ki,
  addIssueToContext: y,
  ParseStatus: X,
  INVALID: S,
  DIRTY: _n,
  OK: te,
  isAborted: yr,
  isDirty: gr,
  isValid: et,
  isAsync: Dt,
  get util() {
    return C;
  },
  get objectUtil() {
    return mr;
  },
  ZodParsedType: _,
  getParsedType: Ne,
  ZodType: T,
  datetimeRegex: Us,
  ZodString: he,
  ZodNumber: Le,
  ZodBigInt: $e,
  ZodBoolean: Mt,
  ZodDate: tt,
  ZodSymbol: bn,
  ZodUndefined: Lt,
  ZodNull: $t,
  ZodAny: _t,
  ZodUnknown: Xe,
  ZodNever: Re,
  ZodVoid: wn,
  ZodArray: pe,
  ZodObject: F,
  ZodUnion: Ft,
  ZodDiscriminatedUnion: An,
  ZodIntersection: Wt,
  ZodTuple: xe,
  ZodRecord: zt,
  ZodMap: kn,
  ZodSet: nt,
  ZodFunction: pt,
  ZodLazy: Vt,
  ZodLiteral: Ut,
  ZodEnum: Fe,
  ZodNativeEnum: Bt,
  ZodPromise: vt,
  ZodEffects: me,
  ZodTransformer: me,
  ZodOptional: we,
  ZodNullable: We,
  ZodDefault: qt,
  ZodCatch: Kt,
  ZodNaN: En,
  BRAND: Ui,
  ZodBranded: Rr,
  ZodPipeline: Xt,
  ZodReadonly: Ht,
  custom: qs,
  Schema: T,
  ZodSchema: T,
  late: Bi,
  get ZodFirstPartyTypeKind() {
    return E;
  },
  coerce: To,
  any: Qi,
  array: ro,
  bigint: Hi,
  boolean: Gs,
  date: Gi,
  discriminatedUnion: oo,
  effect: ys,
  enum: go,
  function: po,
  instanceof: qi,
  intersection: uo,
  lazy: mo,
  literal: yo,
  map: fo,
  nan: Ki,
  nativeEnum: _o,
  never: to,
  null: Yi,
  nullable: wo,
  number: Hs,
  object: so,
  oboolean: Oo,
  onumber: So,
  optional: bo,
  ostring: xo,
  pipeline: Eo,
  preprocess: ko,
  promise: vo,
  record: lo,
  set: ho,
  strictObject: ao,
  string: Ks,
  symbol: Ji,
  transformer: ys,
  tuple: co,
  undefined: Xi,
  union: io,
  unknown: eo,
  void: no,
  NEVER: Ao,
  ZodIssueCode: f,
  quotelessJson: bi,
  ZodError: ie
});
H.object({
  language: H.enum(["typescript", "javascript"]).optional(),
  disableMarkedForExport: H.boolean().optional()
}).and(
  H.union([
    H.object({
      framework: H.literal("react"),
      model: H.string().optional(),
      styling: H.enum([
        "plain_css",
        "css_modules",
        "styled_components",
        "tailwind",
        "sass",
        "scss",
        "inline_styles"
      ]),
      uiLibrary: H.enum(["mui", "antd", "radix", "shadcn"]).optional(),
      enableUILibraryTheming: H.boolean().optional(),
      enableCompactStructure: H.boolean().optional(),
      enableAutoSplit: H.boolean().optional(),
      autoSplitThreshold: H.number().optional()
    }),
    H.object({
      framework: H.literal("html"),
      styling: H.enum(["plain_css", "inline_styles"]),
      enableTranslation: H.boolean().optional()
    })
  ])
);
var Co = Object.defineProperty, No = Object.defineProperties, Po = Object.getOwnPropertyDescriptors, gs = Object.getOwnPropertySymbols, Ro = Object.prototype.hasOwnProperty, Io = Object.prototype.propertyIsEnumerable, _s = (t, e) => (e = Symbol[t]) ? e : Symbol.for("Symbol." + t), Js = (t) => {
  throw TypeError(t);
}, vs = (t, e, n) => e in t ? Co(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, ae = (t, e) => {
  for (var n in e || (e = {}))
    Ro.call(e, n) && vs(t, n, e[n]);
  if (gs)
    for (var n of gs(e))
      Io.call(e, n) && vs(t, n, e[n]);
  return t;
}, Ir = (t, e) => No(t, Po(e)), jr = (t, e, n) => e.has(t) || Js("Cannot " + n), P = (t, e, n) => (jr(t, e, "read from private field"), n ? n.call(t) : e.get(t)), de = (t, e, n) => e.has(t) ? Js("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), J = (t, e, n, r) => (jr(t, e, "write to private field"), e.set(t, n), n), ve = (t, e, n) => (jr(t, e, "access private method"), n), V = (t, e, n) => new Promise((r, s) => {
  var a = (u) => {
    try {
      o(n.next(u));
    } catch (c) {
      s(c);
    }
  }, i = (u) => {
    try {
      o(n.throw(u));
    } catch (c) {
      s(c);
    }
  }, o = (u) => u.done ? r(u.value) : Promise.resolve(u.value).then(a, i);
  o((n = n.apply(t, e)).next());
}), jo = (t, e, n) => (e = t[_s("asyncIterator")]) ? e.call(t) : (t = t[_s("iterator")](), e = {}, n = (r, s) => (s = t[r]) && (e[r] = (a) => new Promise((i, o, u) => (a = s.call(t, a), u = a.done, Promise.resolve(a.value).then((c) => i({ value: c, done: u }), o)))), n("next"), n("return"), e), Zo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Do(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var vr = { exports: {} }, Mo = vr.exports, bs;
function Lo() {
  return bs || (bs = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(Mo, function() {
      var n = typeof Promise == "function", r = typeof self == "object" ? self : Zo, s = typeof Symbol != "undefined", a = typeof Map != "undefined", i = typeof Set != "undefined", o = typeof WeakMap != "undefined", u = typeof WeakSet != "undefined", c = typeof DataView != "undefined", h = s && typeof Symbol.iterator != "undefined", p = s && typeof Symbol.toStringTag != "undefined", k = i && typeof Set.prototype.entries == "function", g = a && typeof Map.prototype.entries == "function", b = k && Object.getPrototypeOf((/* @__PURE__ */ new Set()).entries()), l = g && Object.getPrototypeOf((/* @__PURE__ */ new Map()).entries()), v = h && typeof Array.prototype[Symbol.iterator] == "function", m = v && Object.getPrototypeOf([][Symbol.iterator]()), z = h && typeof String.prototype[Symbol.iterator] == "function", R = z && Object.getPrototypeOf(""[Symbol.iterator]()), q = 8, D = -1;
      function B(I) {
        var $ = typeof I;
        if ($ !== "object")
          return $;
        if (I === null)
          return "null";
        if (I === r)
          return "global";
        if (Array.isArray(I) && (p === !1 || !(Symbol.toStringTag in I)))
          return "Array";
        if (typeof window == "object" && window !== null) {
          if (typeof window.location == "object" && I === window.location)
            return "Location";
          if (typeof window.document == "object" && I === window.document)
            return "Document";
          if (typeof window.navigator == "object") {
            if (typeof window.navigator.mimeTypes == "object" && I === window.navigator.mimeTypes)
              return "MimeTypeArray";
            if (typeof window.navigator.plugins == "object" && I === window.navigator.plugins)
              return "PluginArray";
          }
          if ((typeof window.HTMLElement == "function" || typeof window.HTMLElement == "object") && I instanceof window.HTMLElement) {
            if (I.tagName === "BLOCKQUOTE")
              return "HTMLQuoteElement";
            if (I.tagName === "TD")
              return "HTMLTableDataCellElement";
            if (I.tagName === "TH")
              return "HTMLTableHeaderCellElement";
          }
        }
        var Se = p && I[Symbol.toStringTag];
        if (typeof Se == "string")
          return Se;
        var M = Object.getPrototypeOf(I);
        return M === RegExp.prototype ? "RegExp" : M === Date.prototype ? "Date" : n && M === Promise.prototype ? "Promise" : i && M === Set.prototype ? "Set" : a && M === Map.prototype ? "Map" : u && M === WeakSet.prototype ? "WeakSet" : o && M === WeakMap.prototype ? "WeakMap" : c && M === DataView.prototype ? "DataView" : a && M === l ? "Map Iterator" : i && M === b ? "Set Iterator" : v && M === m ? "Array Iterator" : z && M === R ? "String Iterator" : M === null ? "Object" : Object.prototype.toString.call(I).slice(q, D);
      }
      return B;
    });
  }(vr)), vr.exports;
}
var $o = Lo();
const Fo = /* @__PURE__ */ Do($o), Zr = typeof Buffer != "undefined", Wo = Zr && typeof Buffer.from != "undefined", zo = Zr ? (
  /**
   * is value is Buffer?
   *
   * @param {*} value
   * @return {boolean}
   */
  function(t) {
    return Buffer.isBuffer(t);
  }
) : (
  /**
   * return false
   *
   * NOTE: for Buffer unsupported
   *
   * @return {boolean}
   */
  function() {
    return !1;
  }
), Vo = Wo ? (
  /**
   * copy Buffer
   *
   * @param {Buffer} value
   * @return {Buffer}
   */
  function(t) {
    return Buffer.from(t);
  }
) : Zr ? (
  /**
   * copy Buffer
   *
   * NOTE: for old node.js
   *
   * @param {Buffer} value
   * @return {Buffer}
   */
  function(t) {
    return new Buffer(t);
  }
) : (
  /**
   * shallow copy
   *
   * NOTE: for Buffer unsupported
   *
   * @param {*}
   * @return {*}
   */
  function(t) {
    return t;
  }
);
function bt(t) {
  return zo(t) ? "Buffer" : Fo(t);
}
const Uo = /* @__PURE__ */ new Set([
  "Arguments",
  "Array",
  "Map",
  "Object",
  "Set"
]);
function Bo(t, e, n = null) {
  switch (n || bt(t)) {
    case "Arguments":
    case "Array":
    case "Object":
      return t[e];
    case "Map":
      return t.get(e);
    case "Set":
      return e;
  }
}
function br(t) {
  return Uo.has(t);
}
function ws(t, e, n, r = null) {
  switch (r || bt(t)) {
    case "Arguments":
    case "Array":
    case "Object":
      t[e] = n;
      break;
    case "Map":
      t.set(e, n);
      break;
    case "Set":
      t.add(n);
      break;
  }
  return t;
}
const qo = typeof globalThis != "undefined" && globalThis !== null && globalThis.Object === Object && globalThis, Ko = typeof global != "undefined" && global !== null && global.Object === Object && global, Ho = typeof self != "undefined" && self !== null && self.Object === Object && self, Un = qo || Ko || Ho || Function("return this")();
function Go(t) {
  return t.slice(0);
}
function Jo(t) {
  return new Boolean(t.valueOf());
}
function Xo(t) {
  return new DataView(t.buffer);
}
function Yo(t) {
  return Vo(t);
}
function Qo(t) {
  return new Date(t.getTime());
}
function eu(t) {
  return new Number(t);
}
function tu(t) {
  return new RegExp(t.source, t.flags);
}
function nu(t) {
  return new String(t);
}
function Ae(t, e) {
  return Un[e].from ? Un[e].from(t) : new Un[e](t);
}
function Q(t) {
  return t;
}
function ks() {
  return [];
}
function ru() {
  return /* @__PURE__ */ new Map();
}
function su() {
  return {};
}
function au() {
  return /* @__PURE__ */ new Set();
}
const iu = /* @__PURE__ */ new Map([
  // deep copy
  ["ArrayBuffer", Go],
  ["Boolean", Jo],
  ["Buffer", Yo],
  ["DataView", Xo],
  ["Date", Qo],
  ["Number", eu],
  ["RegExp", tu],
  ["String", nu],
  // typed arrays
  // TODO: pass bound function
  ["Float32Array", Ae],
  ["Float64Array", Ae],
  ["Int16Array", Ae],
  ["Int32Array", Ae],
  ["Int8Array", Ae],
  ["Uint16Array", Ae],
  ["Uint32Array", Ae],
  ["Uint8Array", Ae],
  ["Uint8ClampedArray", Ae],
  // shallow copy
  ["Array Iterator", Q],
  ["Map Iterator", Q],
  ["Promise", Q],
  ["Set Iterator", Q],
  ["String Iterator", Q],
  ["function", Q],
  ["global", Q],
  // NOTE: WeakMap and WeakSet cannot get entries
  ["WeakMap", Q],
  ["WeakSet", Q],
  // primitives
  ["boolean", Q],
  ["null", Q],
  ["number", Q],
  ["string", Q],
  ["symbol", Q],
  ["undefined", Q],
  // collections
  // NOTE: return empty value, because recursively copy later.
  ["Arguments", ks],
  ["Array", ks],
  ["Map", ru],
  ["Object", su],
  ["Set", au]
  // NOTE: type-detect returns following types
  // 'Location'
  // 'Document'
  // 'MimeTypeArray'
  // 'PluginArray'
  // 'HTMLQuoteElement'
  // 'HTMLTableDataCellElement'
  // 'HTMLTableHeaderCellElement'
  // TODO: is type-detect never return 'object'?
  // 'object'
]);
function ou() {
}
function wr(t, e = null, n = ou) {
  arguments.length === 2 && typeof e == "function" && (n = e, e = null);
  const r = e || bt(t), s = iu.get(r);
  if (r === "Object") {
    const a = n(t, r);
    if (a !== void 0)
      return a;
  }
  return s ? s(t, r) : t;
}
function kt(t, e = {}) {
  typeof e == "function" && (e = {
    customizer: e
  });
  const {
    // TODO: before/after customizer
    customizer: n
    // TODO: max depth
    // depth = Infinity,
  } = e, r = bt(t);
  if (!br(r))
    return kr(t, null, null, null);
  const s = wr(t, r, n), a = new WeakMap([[t, s]]), i = new WeakSet([t]);
  return kr(t, s, a, i);
}
function kr(t, e, n, r, s) {
  const a = bt(t), i = wr(t, a);
  if (!br(a))
    return i;
  let o;
  switch (a) {
    case "Arguments":
    case "Array":
      o = Object.keys(t);
      break;
    case "Object":
      o = Object.keys(t), o.push(...Object.getOwnPropertySymbols(t));
      break;
    case "Map":
    case "Set":
      o = t.keys();
      break;
  }
  for (let u of o) {
    const c = Bo(t, u, a);
    if (r.has(c))
      ws(e, u, n.get(c), a);
    else {
      const h = bt(c), p = wr(c, h);
      br(h) && (n.set(c, p), r.add(c)), ws(
        e,
        u,
        kr(
          c,
          p,
          n,
          r
        ),
        a
      );
    }
  }
  return e;
}
const uu = (t) => new Promise((e) => setTimeout(e, t));
var cn, Ge, dn, Er, Xs;
class cu {
  constructor({ maxAttempts: e = 3, func: n }) {
    de(this, Er), de(this, cn), de(this, Ge), de(this, dn), J(this, cn, e), J(this, dn, n), J(this, Ge, 0);
  }
  run() {
    return V(this, null, function* () {
      try {
        return yield P(this, dn).call(this);
      } catch (e) {
        if (J(this, Ge, P(this, Ge) + 1), P(this, Ge) > P(this, cn))
          throw console.error("Max attempts reached"), e;
        const n = ve(this, Er, Xs).call(this);
        return yield uu(n), yield this.run();
      }
    });
  }
}
cn = /* @__PURE__ */ new WeakMap(), Ge = /* @__PURE__ */ new WeakMap(), dn = /* @__PURE__ */ new WeakMap(), Er = /* @__PURE__ */ new WeakSet(), Xs = function() {
  return P(this, Ge) * 1e3 * 1.5;
};
function du() {
  return typeof CompressionStream != "undefined";
}
function lu(t) {
  return V(this, null, function* () {
    const e = new Blob([t]).stream().pipeThrough(new CompressionStream("gzip")), n = [];
    try {
      for (var r = jo(e), s, a, i; s = !(a = yield r.next()).done; s = !1) {
        const o = a.value;
        n.push(o);
      }
    } catch (o) {
      i = [o];
    } finally {
      try {
        s && (a = r.return) && (yield a.call(r));
      } finally {
        if (i)
          throw i[0];
      }
    }
    return yield fu(n);
  });
}
function fu(t) {
  return V(this, null, function* () {
    const e = yield new Blob(t).arrayBuffer();
    return new Uint8Array(e);
  });
}
class hu extends Error {
  constructor({ resource: e, api: n, args: r, cause: s }) {
    if (super(`API Error on resource "${e}" at api "${n}"`), this.causeProperties = {}, this.name = "API Error", this.resource = e, this.api = n, this.cause = s, this.args = r, s instanceof Error)
      for (const [i, o] of Object.entries(s))
        if (typeof Headers != "undefined" && o instanceof Headers) {
          const u = {};
          o.forEach((c, h) => {
            u[h] = c;
          }), this.causeProperties[i] = u;
        } else
          this.causeProperties[i] = o;
    const a = this.causeProperties.body;
    a && typeof a == "object" && "code" in a && (this.code = a.code);
  }
}
class Es extends Error {
  constructor({
    url: e,
    method: n,
    statusCode: r,
    requestHeaders: s,
    responseHeaders: a,
    body: i
  }) {
    if (super("Fetch Error"), this.name = "Fetch Error", this.url = e, this.method = n, this.statusNumber = r, this.requestHeaders = s, this.responseHeaders = a, i)
      try {
        const o = JSON.parse(i);
        this.body = o;
      } catch (o) {
        this.body = i;
      }
  }
}
class Tt extends Error {
  constructor(e = {}) {
    const { canceled: n = !1 } = e;
    super("Abort Error"), this.name = "Abort Error", this.canceled = n;
  }
}
class pu extends Error {
  constructor(e) {
    super(`Async API Error: ${JSON.stringify(e)}`), this.name = "Async API Error", this.body = e;
  }
}
class Bn extends Error {
  constructor(e) {
    super(e), this.name = "Request Validation Error";
  }
}
function Ys() {
  return Array.from(
    { length: 32 },
    () => Math.floor(Math.random() * 256).toString(16).padStart(2, "0")
  ).join("");
}
function xr() {
  return Math.floor(Date.now() / 1e3).toString();
}
const mu = 5 * 60 * 1e3, yu = 1 * 1e3;
var Je, ne, ge, Sr, Or, At;
class gu {
  constructor({ fetch: e = globalThis.fetch.bind(globalThis), baseAddress: n }) {
    de(this, ge), de(this, Je), de(this, ne), this.baseAddress = n, J(this, Je, e), J(this, ne, {}), this.plugins = [];
  }
  get headers() {
    throw new Error("Missing implementation");
  }
  addPlugin(e) {
    this.plugins.push(e);
  }
  removePlugin(e) {
    this.plugins = this.plugins.filter((n) => n.name !== e);
  }
  withOptions(e = {}) {
    return J(this, ne, e), this;
  }
  get(e) {
    return V(this, arguments, function* (n, r = {}) {
      const { overrideBaseAddress: s, overrideDefaultHeaders: a } = r, i = s != null ? s : this.baseAddress;
      let o = a != null ? a : this.headers;
      const u = kt(P(this, ne));
      return J(this, ne, {}), u.extraHeaders && (o = ae(ae({}, o), u.extraHeaders)), u.requestValidation && (o = Ir(ae({}, o), { "X-Request-Nonce": Ys(), "X-Request-Timestamp": xr() })), u.async ? yield ve(this, ge, Or).call(this, `${i}${n}`, u.async, { headers: o }) : yield ve(this, ge, Sr).call(this, `${i}${n}`, u, { headers: o });
    });
  }
  post(e, n) {
    return V(this, arguments, function* (r, s, a = {}) {
      const i = kt(P(this, ne));
      return J(this, ne, {}), ve(this, ge, At).call(this, r, "POST", s, a, i);
    });
  }
  put(e, n) {
    return V(this, arguments, function* (r, s, a = {}) {
      const i = kt(P(this, ne));
      return J(this, ne, {}), ve(this, ge, At).call(this, r, "PUT", s, a, i);
    });
  }
  delete(e, n) {
    return V(this, arguments, function* (r, s, a = {}) {
      const i = kt(P(this, ne));
      return J(this, ne, {}), ve(this, ge, At).call(this, r, "DELETE", s, a, i);
    });
  }
  patch(e, n) {
    return V(this, arguments, function* (r, s, a = {}) {
      const i = kt(P(this, ne));
      return J(this, ne, {}), ve(this, ge, At).call(this, r, "PATCH", s, a, i);
    });
  }
}
Je = /* @__PURE__ */ new WeakMap(), ne = /* @__PURE__ */ new WeakMap(), ge = /* @__PURE__ */ new WeakSet(), Sr = function(t, e, n) {
  return V(this, null, function* () {
    const r = () => V(this, null, function* () {
      var u, c;
      try {
        return yield P(this, Je).call(this, t, ae(ae({}, n), e.abortSignal && { signal: e.abortSignal }));
      } catch (h) {
        throw h instanceof Error && h.name === "AbortError" ? new Tt({ canceled: (c = (u = e.abortSignal) == null ? void 0 : u.aborted) != null ? c : !1 }) : h;
      }
    }), { headers: s } = n != null ? n : {}, a = (u, c) => {
      var h, p;
      return ((h = u == null ? void 0 : u.headers) == null ? void 0 : h.get(c)) || ((p = u == null ? void 0 : u.headersObject) == null ? void 0 : p[c]) || "";
    }, i = (u) => V(this, null, function* () {
      var c;
      if (!u.ok) {
        const p = yield u.text().catch();
        throw new Es({
          url: t,
          method: (c = n == null ? void 0 : n.method) != null ? c : "GET",
          statusCode: u.status,
          requestHeaders: s,
          responseHeaders: u.headers,
          body: p
        });
      }
      if (e.requestValidation && process.env.UI_TESTS !== !0)
        try {
          const p = a(u, "x-response-nonce"), k = s == null ? void 0 : s["X-Request-Nonce"];
          if (!p || p !== k)
            throw new Bn("Response nonce mismatch");
          const g = Number(a(u, "x-response-timestamp")), b = Number(xr()), l = 60 * 60 * 24;
          if (isNaN(g) || Math.abs(b - g) > l)
            throw new Bn("Invalid response timestamp");
        } catch (p) {
          const k = p instanceof Error ? p.message : "Request validation failed";
          throw new Bn(k);
        }
      let h = yield u.text();
      try {
        h = JSON.parse(h);
      } catch (p) {
      }
      return h;
    });
    if (e.retry) {
      const u = yield new cu({
        maxAttempts: e.retry,
        func: r
      }).run();
      return yield i(u);
    }
    const o = yield r();
    return yield i(o);
  });
}, Or = function(t, e, n) {
  return V(this, null, function* () {
    var r, s;
    const {
      onProgress: a,
      abortSignal: i,
      pollingInterval: o = () => yu,
      maxTimeout: u = mu
    } = e, c = `${t}/async`, h = `${t}/async/job`;
    let p;
    try {
      p = yield P(this, Je).call(this, c, ae(ae({}, n), i && { signal: i }));
    } catch (b) {
      throw b instanceof Error && b.name === "AbortError" ? new Tt({ canceled: (r = i == null ? void 0 : i.aborted) != null ? r : !1 }) : b;
    }
    if (!p.ok) {
      const b = yield p.text().catch();
      throw new Es({
        url: t,
        method: (s = n == null ? void 0 : n.method) != null ? s : "GET",
        statusCode: p.status,
        requestHeaders: this.headers,
        responseHeaders: p.headers,
        body: b
      });
    }
    const k = yield p.json(), { job_id: g } = k;
    if (!g)
      throw new Error("Job ID not found in response");
    return new Promise((b, l) => V(this, null, function* () {
      const v = setTimeout(() => {
        l(new Error("Job timed out"));
      }, u), m = (z = 0) => V(this, null, function* () {
        if (i != null && i.aborted) {
          clearTimeout(v), P(this, Je).call(this, `${h}/${g}/cancel`, { method: "POST", headers: this.headers }).then(() => {
            l(new Tt({ canceled: !0 }));
          }).catch((R) => {
            l(new Tt({ canceled: !1 }));
          });
          return;
        }
        try {
          const R = yield (yield P(this, Je).call(this, `${h}/${g}`, { headers: this.headers })).json();
          if (R.status === "success") {
            clearTimeout(v);
            const q = R.response_json;
            b(q);
          } else if (R.status === "failed")
            clearTimeout(v), l(new pu(R.response_json));
          else {
            a && a(R.response_json);
            const q = o(z);
            setTimeout(() => m(z + 1), q);
          }
        } catch (R) {
          l(R);
        }
      });
      m();
    }));
  });
}, At = function(t, e, n, r, s) {
  return V(this, null, function* () {
    const { overrideBaseAddress: a, overrideDefaultHeaders: i } = r, o = a != null ? a : this.baseAddress;
    let u = i != null ? i : this.headers;
    s.extraHeaders && (u = ae(ae({}, u), s.extraHeaders)), s.requestValidation && (u = Ir(ae({}, u), { "X-Request-Nonce": Ys(), "X-Request-Timestamp": xr() }));
    let c = r.skipBodyJsonStringify ? n : JSON.stringify(n);
    return s.compress && du() && (u["Content-Encoding"] = "gzip", c = yield lu(c)), s.async ? yield ve(this, ge, Or).call(this, `${o}${t}`, s.async, {
      method: e,
      headers: u,
      body: c
    }) : yield ve(this, ge, Sr).call(this, `${o}${t}`, s, { method: e, headers: u, body: c });
  });
};
const xs = (t, e, n, r) => t instanceof Tt ? t : new hu({ resource: e, api: String(n), args: r, cause: t }), qn = (t, e) => new Proxy(e, {
  get(n, r) {
    return (...s) => {
      var a;
      for (const o of t.plugins) {
        const u = (a = o.beforeApi) == null ? void 0 : a.call(o, { resource: n.resourceName, api: r, args: s });
        if (u !== void 0)
          return u;
      }
      let i;
      try {
        i = n[r](...s);
      } catch (o) {
        throw xs(o, n.resourceName, r, s);
      }
      return i instanceof Promise ? i.catch((o) => {
        throw xs(o, n.resourceName, r, s);
      }) : i;
    };
  }
});
var Ct;
class _u {
  constructor(e) {
    de(this, Ct), this.resourceName = "Files", J(this, Ct, e);
  }
  get(e) {
    return V(this, arguments, function* ({ fileKey: n, params: r = {} }) {
      const s = new URLSearchParams(ae({
        plugin_data: "857346721138427857"
      }, r)).toString(), a = `v1/files/${n}?${s}`;
      return yield P(this, Ct).get(a);
    });
  }
  getImageFills(e) {
    return V(this, arguments, function* ({ fileKey: n }) {
      var r, s;
      const a = `v1/files/${n}/images`;
      return (s = (r = (yield P(this, Ct).get(a)).meta) == null ? void 0 : r.images) != null ? s : {};
    });
  }
}
Ct = /* @__PURE__ */ new WeakMap();
const vu = (t, e, n) => {
  const r = e.sort();
  return `${t}-${r.join("-")}-${n}`;
}, bu = (t) => t ? t.ts > Date.now() - 1e3 * 30 : !1;
var _e, Tr, Qs;
class wu {
  constructor(e) {
    de(this, Tr), de(this, _e), this.resourceName = "Images", J(this, _e, e);
  }
  /**
   * Return the URL for the _layer_ images for the given nodes.
   * Note: Use the `file.images` API to get the _source_ images used on the node fills, which has better quality.
   */
  get(e) {
    return V(this, arguments, function* ({ fileKey: n, nodeIds: r, format: s = "jpg", scale: a }) {
      const i = vu(n, r, s), o = P(this, _e).cache.images.entries.get(i);
      if (bu(o))
        return o.result;
      o && P(this, _e).cache.images.entries.delete(i);
      const u = P(this, _e).cache.images.pendingRequests.get(i);
      if (u)
        return u;
      const c = ve(this, Tr, Qs).call(this, i, n, r, s, a);
      P(this, _e).cache.images.pendingRequests.set(i, c);
      try {
        return yield c;
      } finally {
        P(this, _e).cache.images.pendingRequests.delete(i);
      }
    });
  }
}
_e = /* @__PURE__ */ new WeakMap(), Tr = /* @__PURE__ */ new WeakSet(), Qs = function(t, e, n, r, s) {
  return V(this, null, function* () {
    const a = yield P(this, _e).get(
      `v1/images/${e}?ids=${n}&format=${r}${s ? `&scale=${s}` : ""}`
    );
    return P(this, _e).cache.images.entries.set(t, {
      result: a,
      ts: Date.now()
    }), a;
  });
};
var ln;
class ku {
  constructor(e) {
    de(this, ln), this.resourceName = "Nodes", J(this, ln, e);
  }
  get(e) {
    return V(this, arguments, function* ({ fileKey: n, nodeIds: r, params: s = {} }) {
      const a = Ir(ae({}, s), {
        ids: r.join(",")
      }), i = new URLSearchParams(ae({
        plugin_data: "857346721138427857"
      }, a)).toString(), o = `v1/files/${n}/nodes?${i}`;
      return yield P(this, ln).get(o);
    });
  }
}
ln = /* @__PURE__ */ new WeakMap();
var je;
class Eu extends gu {
  constructor({
    baseAddress: e = "https://api.figma.com/",
    fetch: n = globalThis.fetch.bind(globalThis)
  } = {}) {
    super({ fetch: n, baseAddress: e }), de(this, je, ""), this.cache = {
      images: {
        entries: /* @__PURE__ */ new Map(),
        pendingRequests: /* @__PURE__ */ new Map()
      }
    }, this.files = qn(this, new _u(this)), this.nodes = qn(this, new ku(this)), this.images = qn(this, new wu(this));
  }
  set token(e) {
    if (!e.startsWith("figd_") && !e.startsWith("figu_"))
      throw new Error("Invalid Figma access token");
    J(this, je, e);
  }
  get token() {
    return P(this, je);
  }
  get headers() {
    const e = {
      "Content-Type": "application/json"
    };
    return P(this, je).startsWith("figd_") ? e["X-FIGMA-TOKEN"] = P(this, je) : P(this, je).startsWith("figu_") && (e.Authorization = `Bearer ${P(this, je)}`), e;
  }
}
je = /* @__PURE__ */ new WeakMap();
const xu = (t) => ke(void 0, [t], function* ({
  fileKey: e,
  authToken: n,
  figmaRestApi: r = new Eu(),
  params: s = {}
}) {
  n && (r.token = n);
  try {
    return yield r.files.get({
      fileKey: e,
      params: s
    });
  } catch (a) {
    throw console.error(a), a;
  }
}), Cu = ({
  fileKey: t,
  authToken: e,
  enabled: n = !0,
  params: r = {}
}) => {
  const s = !!(n && t && e), { data: a, isLoading: i, error: o } = pi(
    ["figma", t, e, r],
    () => s ? xu({
      fileKey: t,
      authToken: e,
      params: r
    }) : null,
    {
      revalidateIfStale: !1,
      revalidateOnFocus: !1,
      revalidateOnReconnect: !1
    }
  );
  return {
    data: a != null ? a : null,
    isLoading: i,
    error: o
  };
};
export {
  Au as useAnimaCodegen,
  Cu as useFigmaFile
};
//# sourceMappingURL=index.js.map
